// ADL
import $ from 'jquery';
import 'jquery-ui/dist/jquery-ui';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/js/dist/modal';
import frm from '../formAux.js'

// ===== STYLES FOR EYE ICON AND TABLE ALIGNMENT =====
const styleBlock = document.createElement('style');
styleBlock.textContent = `
    .reporttable {
        border-collapse: collapse;
        width: 100%;
        table-layout: auto;
    }
    
    .reporttable thead {
        position: sticky;
        top: 0;
        z-index: 10;
    }
    
    .reporttable thead th {
        vertical-align: middle;
        font-weight: 600;
        background-color: #f8f9fa;
        border-bottom: 2px solid #dee2e6;
        padding: 8px 6px;
        font-size: 13px;
        white-space: nowrap;
    }
    
    .reporttable tbody td {
        vertical-align: middle;
        padding: 6px 6px;
        height: auto;
        min-height: 40px;
    }
    
    .reporttable tbody tr {
        border-bottom: 1px solid #e9ecef;
    }
    
    .reporttable tbody tr:hover {
        background-color: #f8f9fa;
    }
    
    .action-cell {
        text-align: center;
        padding: 6px 6px !important;
    }
    
    .visibility-toggle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 4px;
        transition: all 0.15s ease;
        cursor: pointer;
        border: none;
        background: transparent;
        padding: 0;
        margin: 0;
        font-size: 16px;
    }
    .visibility-toggle i.fa-eye {
    color: #7367f0 !important;
}

/* Grey color when hidden */
.visibility-toggle i.fa-eye-slash {
    color: #b9b9c3 !important;
}
    .visibility-toggle:hover {
        background-color: rgba(0, 0, 0, 0.06);
        transform: scale(1.1);
    }
    
    .visibility-toggle:active {
        transform: scale(0.95);
    }
    
    .visibility-toggle i {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .action-edit-delete {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        justify-content: center;
    }
    
    .action-edit-delete button {
        min-height: 28px;
        padding: 2px 8px !important;
    }
`;
document.head.appendChild(styleBlock);
// ===== END STYLES =====

const { Liquid } = require('liquidjs');
// const macros = require('./macros.js'); ---jest test only---
// const { processAndParseTranscript, generateExportString } = require('./transcriptProcessor.js'); ---jest test only---
var mode = 'adl';
var transcriptionData = [];
var selectedLineForAlignmentIndex = null;
var currentlyHighlightedLineIndex = null;
var needsUiRefresh = false;
var currentlyHighlightedWord = { line: -1, word: -1 };
var currentlyHighlightedWord = { line: -1, word: -1 };
var currentlyEditingRow = { index: null };
var transcriptNeedsAlignment = false;
var currentlyActiveRegionId = null;
var userExplicitlySelectedRegion = false; // <-- ADD THIS LINE
var userSelectionTimeout = null; 
var isLoadingData = false;
var inlineTagTooltip = null;
var currentSelectionRange = null;
var currentRegionForTagging = null;
var currentlyClickedTag = null;
var currentTaggingSourceId = null; // <-- ADD THIS LINE
const LOCAL_STORAGE_KEY = 'transcriptDraft';
var closeIcon = '';
var searchIcon = '';
var descriptor = {};
var tagData = descriptor;
var dashjs = window.dashjs;
var WaveSurfer = window.WaveSurver;
var hinst = null;
var jQuery = $;
var modeSelDrop = null;
var wsclicked = false;
var seekPlaying = null;
var tempVisibleRegion = null;
var originalEyeState = null;
var video = $('#video')[0];
var audioObj = $('#audio')[0];
var txtSeparator = ': ';
var wavesurfer = null;
var playToCallback = null;
var declined = false;
var claimed = false;
var released = false;
var reviewMode = false;
var transcriptionMode = false;

let videoClick = false;
let videoClickTid = null;

var currentMode = null;
var currentSeg = null;
var waveMode = null;
var declineReason = '';

var allowOverlap = true;

function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return !isarray(o) && o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function isstring(o) { return typeof (o) == 'string'; }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) {
    if (o === undefined) return undefined;
    return JSON.parse(JSON.stringify(o));
}
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function cancelEvent(ev) { if (!ev) return false; ev.preventDefault(); ev.stopPropagation(); }

function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}

function bool(s) {
    if (typeof (s) == 'boolean') return s;
    if (!defined(s) || s === null) return false;
    if (typeof (s) == 'number') return s > 0;
    if (s.match(/^y/i)) return true;
    return false;
}

function sbool(v) {
    return ['No', 'Yes'][v];
}

var setHeightTid = null;

// function paletteWheel( div, brightness )
// {
// 	if( !brightness ) brightness = 1;
//   	var steps = [[255,0,0],[0,255,0],[0,0,255],[255,0,0]];
//     var colors = [];
//     function interpolate(v)
//     {
//         v *= steps.length-1;
//         var i = Math.floor(v);
//         var r = v-i;
//         var ir = 1-r;
//         // console.log( 'v', v, 'i', i, 'r', r );
//         return [steps[i][0]*ir+steps[i+1][0]*r,steps[i][1]*ir+steps[i+1][1]*r,steps[i][2]*ir+steps[i+1][2]*r];
//     }
//     for( var d = 0 ; d < div ; d++ )
//     {
//         var c = interpolate( d/div);
//         var hc = '#' + c.map( v => Math.min(Math.floor(v*brightness),255).toString(16).padStart(2,'0')).join('');
//         colors.push( hc );
//     }
//     return colors;
// }
// DELETE the entire old stringToColor function.
// REPLACE it with this new, more accurate version.

/**
 * Generates a consistent, visually pleasing and highly distinct color from a string.
 * This version uses the golden angle for hue distribution and hash-based ranges
 * for saturation and lightness to maximize perceptual distance between colors.
 * @param {string} str The tag name to convert into a color.
 * @returns {string} A hex color code (e.g., "#RRGGBB").
 */

function stringToColor(str) {
    if (!str) {
        return '#808080';
    }

    const PREDEFINED_PALETTE = [
        '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6',
        '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3',
        '#808000', '#ffd8b1', '#000075', '#808080', '#ffc107', '#28a745', '#17a2b8', '#6f42c1',
        '#fd7e14', '#20c997', '#d63384', '#6610f2', '#dc3545', '#0dcaf0'
    ];

    // 1. Generate a simple, fast hash from the string.
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash; // Convert to 32bit integer
    }

    // 2. Use the hash to pick a color from the palette.
    const index = Math.abs(hash) % PREDEFINED_PALETTE.length;
    return PREDEFINED_PALETTE[index];
}
function showLockAlert() {
    if (!descriptor) return;

    let lockTxt = "You don't own this task on its current state. Therefore annotations can't be created or modified.";
    if (descriptor.task_can_claim) {
        lockTxt += `<br><br>You may <b>claim</b> the task and become the task owner as <b>${descriptor.task_role}</b>`;
    }

    // Uses myAlert, which is defined later in the file but will be available at runtime.
    myAlert('<i class="fa fa-lock alert-icon"></i> Task Locked', lockTxt, 'Ok');
};
// REPLACE your existing tracks function with this entire block

function tracks(domObj, videoObj, videoSource, tagData, reportObj) {
    // --- FIX START ---
    // Make the report object globally accessible so that the waveReport() function can find it.
    // This solves the issue of the right panel being empty and not refreshing.
    window.reportObj = reportObj;
    // --- FIX END ---

    $('.main').show();

    // [STEP 4 START] SEGMENTATION HELPER FUNCTIONS -----------------------
    // =============================================================================
    // PASTE THIS ENTIRE CORRECTED BLOCK INTO YOUR FILE
    // =============================================================================

    var waveTransparency = '77';

    /**
     * 1. Builds the UI for the mode buttons (Agent, Customer, etc.)
     */
    window.waveMode = function (m) {
        // Set the global current mode from the list of totalModes
        window.currentMode = totalModes[m];
        descriptor.currentMode = window.currentMode;

        // Clear any old buttons
        $('.segmentation').remove();

        // Create a new container for the buttons
        var segContainer = $('<div class="segmentation"></div>')
            .css({
                'display': 'flex', 'align-items': 'center', 'gap': '10px',
                'flex-wrap': 'wrap', 'margin-bottom': '10px', 'padding': '0 15px'
            });
        $('.waveinterface').prepend(segContainer);

        // Render the tag buttons (Agent, Customer, etc.)
        if (window.currentMode.type === 'segmentation' && Array.isArray(window.currentMode.options)) {
            window.currentMode.options.forEach((option, index) => {
                var color = window.currentMode.colors[index % window.currentMode.colors.length];
                // REPLACE with this NEW, correct JavaScript
                var btn = $('<div>')
                    .html(option)
                    .prop('id', 'segbtn-' + index)
                    .attr('data-segindex', index)
                    .addClass('segmentation-opt unselectable')
                    // ONLY set the dynamic color with JavaScript. The class will handle the rest.
                    .css({
                        'border-left-color': color
                    });
                segContainer.append(btn);
            });
            // Hide the full-size segmentation bar — we keep the compact clone next to zoom controls
            segContainer.hide();
        }

        // Logic for "+ Add segmentation" button
        if (window.currentMode.allowNew) {
            // (Existing code for the add button can remain here)
        }

        if (window.wavesurfer) {
            if (window.descriptor && window.descriptor.blockEdit) {
            window.wavesurfer.disableDragSelection();
        } else {
            // If the task is editable, enable drag selection.
            window.wavesurfer.enableDragSelection({
                color: 'rgba(0, 255, 0, 0.1)', // A neutral default color
                drag: true
            });
        }
        }

        // Update the cloned buttons in the zoom area
        try {
            const zoomContainer = $('.zoom-seg-buttons');
            if (zoomContainer.length) {
                zoomContainer.empty();
                const cloned = $('.segmentation .segmentation-opt').clone(true);
                cloned.each(function () { $(this).addClass('segmentation-opt-small'); });
                zoomContainer.append(cloned);
            }
        } catch (e) { /* fail silently if DOM not ready */ }
    };

    /**
     * 2. Handles clicking a tag button. This is where the state is set.
     */
    window.waveSegSelect = function (id) {
        // THIS IS THE KEY: Set the global variable to the index of the clicked button.
        window.currentSeg = id;

        var mode = window.currentMode || descriptor.currentMode;
        if (!mode || !mode.colors) return;
        var color = mode.colors[id % mode.colors.length];

        // --- FIX ---
        // Change the background color here from '#e9ecef' to '#ffffff'
        // This resets all non-selected buttons to white instead of grey.
        $('.segmentation-opt').css({ 'background': '#ffffff', 'color': '#333', 'font-weight': 'normal' });

        // Use data attribute to select ALL matching buttons (fixes issue with cloned buttons)
        $('[data-segindex="' + id + '"]').css({ 'background': color + '33', 'font-weight': 'bold', 'color': '#000' });

        // Set the drag color for the NEXT region you draw.
        if (window.wavesurfer) {
            window.wavesurfer.enableDragSelection({
                color: color + waveTransparency,
                drag: true
            });

            // If a region is ALREADY selected, change its tag to this one.
            if (window.wavesurfer.selectedRegion) {
                var region = window.wavesurfer.regions.list[window.wavesurfer.selectedRegion];
                if (region) {
                    region.data.tag = mode.options[id];
                    region.data.track = mode.name;
                    region.data.mode = mode.id;
                    region.update({ color: color + waveTransparency });
                    if (window.waveReport) window.waveReport();
                    changed();
                }
            }
        }
    }

    // PASTE THIS NEW, SINGLE VERSION WHERE THE FIRST FUNCTION WAS
    /**
     * Adds a text label on top of a waveform region.
     * @param {object} region The WaveSurfer region object.
     * @param {string} text The text to display on the label.
     */
    function waveRegionText(region, text) {
        if (!region || !region.element) return;

        // Remove any existing label first to prevent duplicates on update
        $(region.element).find('.waveform-region-label').remove();

        // Do not add a label if the text is empty
        if (!text) return;

        // Create the new label element
        const label = $('<div>')
            .addClass('waveform-region-label unselectable')
            .text(text);

        // Append the new label to the region's visual element
        $(region.element).append(label);
    }
// ADL
window.waveRegionUpdate = function (region) {
    if (window.descriptor && window.descriptor.blockEdit) {
        return; // Exit if editing is blocked
    }

    // This check is for MANUAL creation. It won't run during initial data load.
    if (!isLoadingData && (window.currentSeg === null || typeof window.currentSeg === 'undefined')) {
        myAlert('Selection Required', 'Please select a speaker tag (e.g., Agent, Customer) before creating a segment.');
        return;
    }

    if (!region.data) region.data = {};

    // >>> THIS IS THE FIX <<<
    // Only set the row to "editing" if we are NOT in the middle of loading data.
    if (!isLoadingData) {
        currentlyEditingRow.index = region.id;
    }

    var activeMode = window.currentMode || descriptor.currentMode;
    if (!activeMode) return;
    const $scrollContainer = $('.reporttable tbody');
    const oldScrollTop = $scrollContainer.scrollTop() || 0;

    if (!region.data.tag) {
        var segIndex = window.currentSeg;
        region.data.tag = activeMode.options[segIndex];
        region.data.track = activeMode.name;
        region.data.mode = activeMode.id;
        var color = activeMode.colors[segIndex % activeMode.colors.length];
        var finalColor = color + waveTransparency;
        region.data.originalColor = finalColor;
        region.update({ color: finalColor, drag: false, resize: true });
    }

    waveRegionText(region, region.data.tag);

    const primaryTypeOptions = (activeMode && activeMode['Primary Type']);
    if (!region.data.tone && Array.isArray(primaryTypeOptions) && primaryTypeOptions.length > 0) {
        region.data.tone = primaryTypeOptions[0];
    }

    const loudnessOptions = (activeMode && activeMode['Loudness Level']);
    if (!region.data.loudness && Array.isArray(loudnessOptions) && loudnessOptions.length > 0) {
        region.data.loudness = loudnessOptions[0].trim();
    } else if (!region.data.loudness) {
        region.data.loudness = "Normal";
    }
    
    if (!region.data.language) region.data.language = "";
    if (!region.data.segmentLanguage) region.data.segmentLanguage = "";
    if (!region.data.transcriptionLatin) region.data.transcriptionLatin = "";

    if (typeof window.waveReport === 'function') window.waveReport();
    changed();

    if (currentlyActiveRegionId && currentlyActiveRegionId !== region.id) {
        $('#wavereport' + currentlyActiveRegionId).removeClass('table-active');
    }
    currentlyActiveRegionId = region.id;
    if (currentlyActiveRegionId) {
        $('#wavereport' + currentlyActiveRegionId).addClass('table-active');
    }
    updateAllRegionHighlights();

    // Only scroll and focus when a user manually creates a region.
    if (!isLoadingData) {
        requestAnimationFrame(() => {
            const $newScrollContainer = $('.reporttable tbody');
            const $newRow = $('#wavereport' + region.id);
            if ($newRow.length && $newScrollContainer.length) {
                $newScrollContainer.scrollTop(oldScrollTop);
                const newScrollTop = $newScrollContainer.scrollTop() + $newRow.position().top - ($newScrollContainer.height() / 2) + ($newRow.height() / 2);
                $newScrollContainer.stop(true, true).animate({ scrollTop: newScrollTop }, 400);
                $newRow.find('.transcription-input').focus();
            }
        });
    }
}

    const metadata = {
        ...(tagData.metadata || {}),
        ...(tagData.media ? tagData.media.metadata : {})
    };

    // Check if there is any metadata to display.
    if (Object.keys(metadata).length > 0) {
        // Find the main container to ensure we don't add duplicate metadata bars.
        const parentContainer = domObj.parent();
        parentContainer.find('.media-metadata-display').remove();

        // Create the new element for the metadata.
        const metadataDiv = $('<div class="media-metadata-display"></div>');

        // Build the HTML string from the metadata object (e.g., "File: ... TaskId: ...").
        const metadataHtml = Object.entries(metadata)
            .map(([key, value]) => `<span><b>${key}:</b> ${value}</span>`)
            .join('&nbsp;&nbsp;&nbsp;&nbsp;'); // Add more space for clarity

        // Apply styling and add the content.
        metadataDiv.html(metadataHtml).css({
            'padding': '8px 15px',
            'font-size': '0.85rem',
            'font-family': 'sans-serif',
            'color': '#5e5873',
            'border-bottom': '1px solid #e8e8e8',
            'margin-bottom': '0'
        });

        // Prepend the metadata bar before the WaveSurfer container itself.
        domObj.before(metadataDiv);
    }
    setTimeout(function () {

        var mediaType = null, waveReady = false, waveHeight = 100, waveZoom = 8;
        let isSeeking = false; // Critical flag to know when the user is dragging the seek bar.
        video = videoObj[0];

        function setHeight() {
            // Ensure the report panel object exists. reportObj is defined as $('#reportpanel')
            if (!reportObj || !reportObj.length) return;

            // Get the current vertical position of the top of the report panel relative to the document
            const reportPanelOffsetTop = reportObj.offset().top;
            
            // Get the total height of the browser window
            const windowHeight = $(window).height();

            // Calculate the available height from the top of the panel to the bottom of the window.
            // A 20px padding is left at the bottom for better spacing.
            const availableHeight = windowHeight - reportPanelOffsetTop - 20;

            // Enforce a minimum height (e.g., 250px) to ensure the panel is always usable.
            const newPanelHeight = Math.max(availableHeight, 250);

            // Apply the calculated height to the main report panel container.
            reportObj.css('height', newPanelHeight + 'px');

            // The scrollable body of the table should be the panel's height minus its header's height.
            // We'll estimate the non-scrolling table header height as 45px.
            const tbodyHeight = newPanelHeight - 45;

            // Apply the calculated max-height to the table body, which enables it to scroll correctly.
            $('.reporttable tbody').css('max-height', tbodyHeight + 'px');
        }

        function formatTimeCallback(seconds) {
            seconds = isNaN(seconds) || seconds < 0 ? 0 : seconds;
            const date = new Date(seconds * 1000);
            const minutes = date.getUTCMinutes();
            const secs = date.getUTCSeconds().toString().padStart(2, '0');
            if (date.getUTCHours() > 0) {
                return `${date.getUTCHours()}:${minutes.toString().padStart(2, '0')}:${secs}`;
            }
            return `${minutes}:${secs}`;
        }


        function waveZoomUpdate() {
            if (wavesurfer) wavesurfer.zoom(waveZoom * 10);
            $('#zoom-slider').val(waveZoom);
            $('.wave-zoom-txt').html(Math.round(waveZoom) + 'X');
        }
        function waveZoomIn() {
            if (waveZoom < 32) {
                waveZoom++;
            }
            waveZoomUpdate();
        }
        function waveZoomOut() {
            if (waveZoom > 8) {
                waveZoom--;
            }
            waveZoomUpdate();
        }
        function waveRate(r) { if (wavesurfer) { wavesurfer.setPlaybackRate(r); video.playbackRate = r; $('.wave-rate').removeClass('wave-rate-selected'); $(`.v${r.toString().replace('.', '')}`).addClass('wave-rate-selected'); $('#speed-select').val(r); } }

function wavePanel() {
    $('.wavepanel, .player-seek-container, .player-controls-container, .zoom-controls-row').remove();

    // --- HEADER CONTAINER for the 3 Control Rows ---
    const headerContainer = $('<div>').addClass('player-controls-container');

    // === ROW 1: MEDIA BUTTONS ===
    const mediaRow = $('<div>').addClass('control-row media-row');
    const btnGroup = $('<div>').addClass('media-btn-group');

    const btns = [
        { icon: 'fa-fast-backward', title: 'Jump to Start', action: () => wavesurfer && wavesurfer.setCurrentTime(0) },
        { icon: 'fa-step-backward', title: 'Step Backward', action: () => wavesurfer && wavesurfer.skipBackward(5) },
        { icon: 'fa-play', title: 'Play/Pause', id: 'play-pause-btn', action: () => wavesurfer && wavesurfer.playPause() },
        { icon: 'fa-step-forward', title: 'Step Forward', action: () => wavesurfer && wavesurfer.skipForward(5) },
        { icon: 'fa-fast-forward', title: 'Jump to End', action: () => { if (!wavesurfer) return; wavesurfer.seekTo(1); } }
    ];

    btns.forEach(b => {
        const btn = $('<button>').addClass('ctrl-btn').attr('title', b.title).html(`<i class="fa ${b.icon}"></i>`);
        if (b.id) btn.attr('id', b.id);
        btn.on('click', () => { if (window.descriptor.blockEdit) return showLockAlert(); b.action(); });
        btnGroup.append(btn);
    });

    mediaRow.append(btnGroup);
    const inlineSeek = $('<div>').addClass('player-seek-container-inline');
    const inlineSeekBar = $('<div>').addClass('player-progress-bar').html('<div class="player-progress-fill"></div><div class="player-progress-thumb" role="slider" tabindex="0" aria-label="Seek"></div>');
    inlineSeek.append(inlineSeekBar);
    mediaRow.append(inlineSeek);
    headerContainer.append(mediaRow);

    // === ROW 2: OPTIONS (Speaker, 1x, 1, Toggle ... Time) ===
    const optionsRow = $('<div>').addClass('control-row options-row');
    const leftOptions = $('<div>').addClass('options-left');

    // Speaker icon (clickable to toggle mute)
    const speakerIcon = $('<i>').addClass('fa fa-volume-up speaker-icon').css('cursor', 'pointer').on('click', function () {
        try { $('#mute-toggle').prop('checked', !$('#mute-toggle').prop('checked')).trigger('change'); } catch (e) { /* muteCheck may not be created yet */ }
    });
    leftOptions.append(speakerIcon);

    // --- Mute toggle (MOVED HERE) ---
    const muteToggle = $('<label>').addClass('toggle-switch').attr('title', 'Mute audio');
    const muteCheck = $('<input type="checkbox">').attr('id', 'mute-toggle').attr('aria-label', 'Mute audio');
    const muteSlider = $('<span>').addClass('slider round');
    muteToggle.append(muteCheck, muteSlider);
    muteCheck.on('change', function () {
        const isMuted = $(this).is(':checked');
        try { if (wavesurfer) wavesurfer.setMute(isMuted); } catch (e) { }
        if (isMuted) {
            speakerIcon.removeClass('fa-volume-up').addClass('fa-volume-off');
        } else {
            speakerIcon.removeClass('fa-volume-off').addClass('fa-volume-up');
        }
    });
    leftOptions.append(muteToggle);

    // Speed dropdown (1x)
    const speedSel = $('<select>').addClass('custom-select speed-select').attr('id', 'speed-select');
    [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 4, 8].forEach(r => speedSel.append($('<option>').val(r).text(r + 'x').prop('selected', r === 1)));
    speedSel.on('change', function () { if (!window.descriptor.blockEdit) waveRate(parseFloat($(this).val())); else showLockAlert(); });
    const speedWrapper = $('<div class="custom-select-wrapper speed-wrapper"></div>').append(speedSel);
    leftOptions.append(speedWrapper);

    // --- FIX: Reordered the toggle creation logic for correct layout ---

    // --- 1. Enable Transliteration Toggle (Label + Switch) ---
    const transliterateLabel = $('<span>').addClass('player-controls-container .toggle-label').css({'margin-left': '10px','font-size':'13px'}).text('Enable transliteration');
    leftOptions.append(transliterateLabel);
            
    const transliterateToggle = $('<label>').addClass('toggle-switch').attr('title', 'Show/Hide Transliteration Column');
    const transliterateCheck = $('<input type="checkbox">').attr('id', 'transliterate-toggle');
    const transliterateSlider = $('<span>').addClass('slider round');
    transliterateToggle.append(transliterateCheck, transliterateSlider);

    transliterateCheck.on('change', function () {
        const isEnabled = $(this).is(':checked');
        descriptor.isTransliterationEnabled = isEnabled;
        window.descriptor.isTransliterationEnabled = isEnabled;
        if (isEnabled) {
            $('.latin-column').show();
        } else {
            $('.latin-column').hide();
        }
        $(window).trigger('resize');
        changed();
    });

    leftOptions.append(transliterateToggle);


    // --- 2. Tagged Output View Toggle (Label + Switch) ---
    const taggedViewLabel = $('<span>').addClass('player-controls-container .toggle-label').css({'margin-left': '10px','font-size':'13px'}).text('Tagged Output View');
    leftOptions.append(taggedViewLabel);
        
    const taggedViewToggle = $('<label>').addClass('toggle-switch').attr('title', 'Show final tagged output in the table');
    const taggedViewCheck = $('<input type="checkbox">').attr('id', 'tagged-output-toggle');
    const taggedViewSlider = $('<span>').addClass('slider round');
    taggedViewToggle.append(taggedViewCheck, taggedViewSlider);
        
    taggedViewCheck.on('change', function () {
        // Refresh the report table to reflect the new view mode
        if (window.waveReport) {
            window.waveReport();
        }
    });

    leftOptions.append(taggedViewToggle);
    // --- END OF FIX ---


    // Channel dropdown (1)
    const chanSel = $('<select>').addClass('custom-select channel-select').attr('id', 'channel-select').hide();
    chanSel.append($('<option>').val('1').text('1'), $('<option>').val('2').text('2'));
    const chanWrapper = $('<div class="custom-select-wrapper"></div>');
    chanWrapper.append(chanSel);
    if (chanSel.is(':hidden')) {
        chanWrapper.addClass('hidden-wrapper').hide();
    }
    leftOptions.append(chanWrapper);

    optionsRow.append(leftOptions);

    // Time display (right side)
    const timeDisplay = $('<div>').addClass('time-display');
    timeDisplay.html('<span class="time-label">Time</span> <span id="time-display" class="time-val">0.000/0:00.000</span>');
    optionsRow.append(timeDisplay);
    headerContainer.append(optionsRow);

    // === ROW 3: ZOOM CONTROLS ONLY ===
    const zoomRow = $('<div>').addClass('control-row zoom-row');
    const zoomWrapper = $('<div>').addClass('zoom-controls');
    const zoomLeft = $('<div>').addClass('zoom-left');
    const zoomRight = $('<div>').addClass('zoom-right');
    const zoomSegButtons = $('<div>').addClass('zoom-seg-buttons');
    const segBtns = $('.segmentation .segmentation-opt').clone(true);
    if (segBtns.length) {
        segBtns.each(function () { $(this).addClass('segmentation-opt-small'); });
        zoomSegButtons.append(segBtns);
    }
    zoomRight.append(zoomSegButtons);
    zoomLeft.append($('<button>').addClass('zoom-btn').html('<i class="fa fa-search-minus"></i>').on('click', () => { if (!window.descriptor.blockEdit) { waveZoomOut(); } else showLockAlert(); }));
    const zSlider = $('<input type="range">').addClass('zoom-slider').attr({ 'id': 'zoom-slider', 'min': '8', 'max': '32', 'value': waveZoom, 'step': '1' });
    zSlider.on('input', function () { if (!window.descriptor.blockEdit) { waveZoom = parseInt($(this).val()); waveZoomUpdate(); } else showLockAlert(); });
    zoomLeft.append(zSlider);
    zoomLeft.append($('<button>').addClass('zoom-btn').html('<i class="fa fa-search-plus"></i>').on('click', () => { if (!window.descriptor.blockEdit) { waveZoomIn(); } else showLockAlert(); }));
    zoomLeft.append($('<span>').addClass('wave-zoom-txt').html(waveZoom + 'X'));
    zoomWrapper.append(zoomLeft, zoomRight);
    zoomRow.append(zoomWrapper);
    headerContainer.append(zoomRow);
    $('.waveinterface').prepend(headerContainer);
}

        domObj.empty();

        // Create timeline and waveform containers directly (like working code)
        domObj.append($('<div>').prop('id', 'waveformindex'), $('<div>').prop('id', 'waveform'), $('<div>').addClass('waveinterface'));


        if (tagData.audioSource) {
            $('#video').hide();
            video = $('#audio')[0];
            $(video).hide(); // Hide audio element (custom controls used)
            mediaType = 'audio';
            waveHeight = 150;
        } else {
            $('#audio').hide();
            video = $('#video')[0];
            $(video).show().prop('controls', true);
            mediaType = 'video';
            waveHeight = 100;
        }

        wavesurfer = window.WaveSurfer.create({
            container: '#waveform',
            waveColor: '#7367f0', // Blue/purple
            progressColor: '#aaa',
            cursorColor: '#4a47a3',
            backgroundColor: '#fff',
            height: waveHeight,
            backend: 'MediaElement',
            scrollParent: true,
            autoCenter: true,
            normalize: true,
            responsive: true,
            barWidth: 2,
            barGap: 1,
            plugins: [
                window.WaveSurfer.minimap.create({
                    height: 30,
                    waveColor: '#ccc',
                    progressColor: '#777',
                    cursorColor: '#333'
                }),
                window.WaveSurfer.timeline.create({
                    container: '#waveformindex',
                    formatTimeCallback: formatTimeCallback,
                    timeInterval: 1,
                    primaryLabelInterval: 5,
                    secondaryLabelInterval: 1
                }),
                window.WaveSurfer.regions.create({
                    dragSelection: false,
                    drag: false,
                    allowOverlap: allowOverlap,
                    formatTimeCallback: function (start, end) {
                        return `${start.toFixed(3)} - ${end.toFixed(3)}`;
                    }
                })
            ]
        });
        window.wavesurfer = wavesurfer;

        wavesurfer.on('region-update-end', function (r) { window.waveRegionUpdate(r); });
        wavesurfer.on('region-created', function (r) { window.waveRegionUpdate(r); });

        wavesurfer.on('region-click', function (region, e) {
            if (region.data && region.data.tag && window.currentMode) {
                var idx = window.currentMode.options.indexOf(region.data.tag);
                if (idx > -1) {
                    window.waveSegSelect(idx);
                }
            }
            try {
                // Mark that the user explicitly selected via waveform click
                userExplicitlySelectedRegion = true;
                clearTimeout(userSelectionTimeout);

                // Update active region id and highlights
                if (currentlyActiveRegionId && currentlyActiveRegionId !== region.id) {
                    $('#wavereport' + currentlyActiveRegionId).removeClass('table-active');
                }
                currentlyActiveRegionId = region.id;
                updateAllRegionHighlights();

                // Scroll the table to bring the corresponding row into view
                const $tbody = $('.reporttable tbody');
                const $row = $('#wavereport' + region.id);
                if ($tbody.length && $row.length) {
                    const newScrollTop = Math.max(0, $tbody.scrollTop() + $row.position().top - ($tbody.height() / 2) + ($row.height() / 2));
                    $tbody.stop(true, true).animate({ scrollTop: newScrollTop }, 200);
                    $row.addClass('table-active');
                }

                // Keep the explicit selection flag briefly so other logic can respect it
                userSelectionTimeout = setTimeout(() => { userExplicitlySelectedRegion = false; }, 250);
            } catch (err) {
                console.error('Error handling region-click table sync:', err);
            }
        });
        // Initial Call to build the header
        wavePanel();

        $('head').append($('<style>').prop('id', 'player-styles').text(`
            #transcription-display-area:focus,
#transliteration-display-area:focus {
    outline: none;
    box-shadow: none;
}
            /* Find this CSS rule in your style block */
.speaker-select-cell {
    /* Core styling to make it look like plain text */
    border: none;
    background: transparent;
    box-shadow: none;
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.15s ease-in-out;

    /* ADD THIS LINE to prevent the column from shrinking */
}
            /* Waveform region label styling */
.waveform-region-label {
    position: absolute;
    top: 4px;
    left: 6px;
    color: black; /* CHANGED from white to black */
    font-size: 11px;
    font-weight: bold;
    /* CHANGED shadow to a light color for better contrast */
    // text-shadow: 0px 0px 4px rgba(255, 255, 255, 0.9), 1px 1px 4px rgba(255, 255, 255, 0.7);
    padding: 1px 4px;
    z-index: 4; /* Ensures label is on top of the region color */
    pointer-events: none; /* Allows clicks to pass through to the region */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 95%;
}
    /* =================== CONTAINER =================== */
    .waveinterface {
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        background: #fff;
        overflow: hidden;
    }

    /* =================== HEADER CONTROLS (3 Rows) =================== */
    .player-controls-container {
        background: #fff;
        border-bottom: 1px solid #e0e0e0;
    }

    .control-row {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        border-bottom: 1px solid #f0f0f0;
        min-height: 36px;
    }
    
    .control-row:last-child {
        border-bottom: none;
    }

    /* --- Row 1: Media --- */
    .media-row {
        gap: 8px;
    }

    .media-btn-group {
        display: flex;
        gap: 2px;
        flex: 0 0 auto;
    }

    .ctrl-btn {
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 3px;
        color: #333;
        font-size: 11px;
        cursor: pointer;
        width: 26px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.1s;
    }

    .ctrl-btn:hover {
        background: #f5f5f5;
        border-color: #bbb;
    }
    
    .ctrl-btn:active {
        background: #e0e0e0;
        box-shadow: inset 0 1px 2px rgba(0,0,0,0.1);
    }

    .loading-spinner {
        color: #7367f0;
        font-size: 14px;
        margin-left: 6px;
    }

    /* --- Row 2: Options --- */
    .options-row {
        justify-content: space-between;
        background: #fff;
    }

    .options-left {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .speaker-icon-static {
        color: #555;
        font-size: 14px;
    }

    .custom-select-wrapper {
        position: relative;
    }

    .custom-select {
        height: 24px;
        padding: 2px 20px 2px 8px;
        font-size: 12px;
        color: #333;
        background: #fff;
        background-image: none !important;
        border: 1px solid #ccc;
        border-radius: 12px; /* Pill shape for 1x */
        appearance: none;
        -webkit-appearance: none;
        cursor: pointer;
        line-height: 1.2;
    }
    
    .speed-select {
        min-width: 50px;
    }
    
    .channel-select {
        min-width: 40px;
        border-radius: 4px; /* Square for channel */
    }

    /* Custom Arrow for selects */
    .custom-select-wrapper::after {
        content: '▾';
        position: absolute;
        top: 50%;
        right: 8px;
        transform: translateY(-50%);
        font-size: 10px;
        color: #666;
        pointer-events: none;
        line-height: 1;
    }

    /* Better centered arrow for speed-select wrappers */
    .custom-select-wrapper.speed-wrapper {
        display: inline-flex;
        align-items: center;
    }

    .custom-select-wrapper.speed-wrapper::after {
        right: 6px;
        font-size: 11px;
        color: #555;
    }

    /* When a wrapper is intentionally hidden, don't show the pseudo-arrow */
    .custom-select-wrapper.hidden-wrapper::after { display: none !important; }

    /* Reserve padding for the dropdown arrow */
    .custom-select.speed-select { padding-right: 18px; }

    /* Toggle Switch */
    .toggle-switch {
        position: relative;
        display: inline-block;
        width: 34px;
        height: 18px;
        margin-bottom: 0;
    }
    
    .toggle-switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }
    
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #ccc;
        transition: .2s;
        border-radius: 18px;
    }
    
    .slider:before {
        position: absolute;
        content: "";
        height: 14px;
        width: 14px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: .2s;
        border-radius: 50%;
        z-index: 2;
    }
    
    input:checked + .slider {
        background-color: #7367f0;
    }
    
    input:checked + .slider:before {
        transform: translateX(16px);
    }
    
    .toggle-icon-off {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 10px;
        color: #fff;
        z-index: 1;
    }

    .player-controls-container .toggle-label {
        font-size: 12px;
        margin-left: 6px;
        color: #333;
        display: inline-flex;
        align-items: center;
        height: 18px;
    }

    .time-display {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .time-label {
        font-weight: bold;
        font-size: 11px;
        color: #333;
    }
    
    .time-val {
        font-family: monospace;
        font-size: 12px;
        color: #333;
    }

    /* --- Row 3: Zoom --- */
    .zoom-row {
        background: #fff;
        padding: 4px 10px;
        min-height: 28px;
        border-bottom: none;
    }

    .zoom-controls {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 6px;
        width: 100%;
    }

    .zoom-left {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .zoom-right {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    /* Compact segmentation buttons placed near zoom area */
    .zoom-seg-buttons {
        display: flex;
        gap: 6px;
        align-items: center;
    }

    /* PASTE THIS NEW CODE in place of the old block */
/* ADD THIS NEW, CORRECT RULE TO YOUR STYLESHEET */
.segmentation-opt {
    background: #ffffff;
    border: 1px solid #a9c5e7; /* Light blue border */
    border-left-width: 5px;   /* Set the width for the colored bar */
    padding: 3px 12px;
    border-radius: 4px;
    font-size: 13px;
    color: #212529;
    cursor: pointer;
    line-height: 1.4;
}

    .segmentation-opt-small.unselectable { user-select: none; }

    .zoom-btn {
        background: none;
        border: none;
        color: #7367f0;
        cursor: pointer;
        font-size: 14px;
        padding: 4px;
    }

    .zoom-btn:hover {
        color: #5a4fd1;
    }

    .zoom-slider {
        -webkit-appearance: none;
        height: 3px;
        background: #ddd;
        outline: none;
        width: 80px;
        flex-shrink: 0;
        border-radius: 2px;
    }
    
    .zoom-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #7367f0;
        cursor: pointer;
    }

    .wave-zoom-txt {
    background-color: #7367f0;
    color: white;
    font-size: 12px;
    font-weight: bold;
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    line-height: 1;
    padding: 0;

    /* --- THESE ARE THE CHANGES --- */
    width: 30px;          /* Reduced size */
    height: 30px;         /* Reduced size */
    cursor: default;      /* Prevents text-selection cursor */
}

    /* =================== TRACK LAYOUT (Sidebar + Content) =================== */
    .wave-tracks-container {
        display: flex;
        flex-direction: column;
        background: #fff;
        border-top: 1px solid #e0e0e0;
    }

    .track-row {
        display: flex;
        border-bottom: 1px solid #e0e0e0;
        min-height: 30px;
    }

    .track-row:last-child {
        border-bottom: none;
    }

    .track-sidebar {
        width: 90px; /* Sidebar for labels */
        flex-shrink: 0;
        background: #fafafa;
        border-right: 1px solid #e0e0e0;
        display: flex;
        align-items: center;
        padding: 0 8px;
        font-size: 11px;
        color: #333;
        gap: 4px;
    }

    .track-sidebar i {
        color: #666;
    }

    .track-content {
        flex-grow: 1;
        position: relative;
        overflow-x: auto; /* Allow horizontal scroll for waveform */
        overflow-y: visible;
        min-width: 0;
        background: #fff;
    }

    /* Waveform track row */
    .waveform-track-row {
        min-height: 120px;
    }
@media (min-width: 992px) {
    .mt-lg-5, .my-lg-5 {
        margin-top: 1rem !important;
    }
}
    .waveform-track-row .track-sidebar {
        align-items: flex-start;
        padding-top: 8px;
    }

    /* Specific Track Styling */
    .file-info {
        display: flex;
        align-items: center;
        gap: 6px;
    }
    
    .file-info i {
        color: #666;
    }

    /* Word Track Sidebar */
    .word-sidebar {
        background: #fafafa;
        gap: 4px;
    }

    .word-controls {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .icon-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        color: #666;
    }

    /* Make small icon buttons visually match the main media controls */
    .icon-btn {
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 3px;
        color: #333;
        cursor: pointer;
        width: 26px;
        height: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        transition: all 0.08s ease;
        box-sizing: border-box;
    }

    .icon-btn:hover {
        background: #f5f5f5;
        border-color: #bbb;
    }

    .icon-btn:active {
        background: #eaeaea;
        box-shadow: inset 0 1px 2px rgba(0,0,0,0.06);
    }

    .square-btn i { font-size: 13px; }
    .audio-btn i { font-size: 13px; color: #e74c3c; } /* Red speaker */

    .track-name {
        margin-left: 4px;
        color: #555;
    }

    /* Segments Display */
    .word-track-segments {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        padding-left: 2px;
        /* Placeholder visualization */
        background: linear-gradient(90deg, 
            transparent 10%, 
            #8B4513 10%, #8B4513 12%, 
            transparent 12%, transparent 15%,
            #8B4513 15%, #8B4513 18%,
            transparent 18%
        );
        opacity: 0.7;
    }

    /* Waveform Overrides */
    #waveform {
        border: none;
        background: #fff;
        min-height: 100px;
    }

    .wavesurfer-timeline {
        font-size: 10px !important;
        color: #666 !important;
    }
    
    /* Scrollbar for waveform */
    #waveform::-webkit-scrollbar {
        height: 10px;
    }
    
    #waveform::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-top: 1px solid #e0e0e0;
    }
    
    #waveform::-webkit-scrollbar-thumb {
        background: #999;
        border-radius: 5px;
        border: 2px solid #f1f1f1; /* Padding effect */
    }
    
    #waveform::-webkit-scrollbar-thumb:hover {
        background: #777;
    }

    /* Hide Old Elements (we use our new header layout) */
    .wavepanel, .player-seek-container, .wave-rate, .control-group {
        display: none !important;
    }

    /* Inline progress bar placed next to the media buttons */
    .player-seek-container-inline {
        display: flex;
        align-items: center;
        margin-left: 8px;
        flex: 1 1 auto;
    }

    .player-progress-bar {
        width: 100%;
        height: 8px;
        background: #e8e8ee;
        border-radius: 6px;
        overflow: visible;
        cursor: pointer;
        position: relative;
    }

    .player-progress-fill {
        height: 100%;
        width: 0%;
        background: #7367f0;
        border-radius: 6px;
        /* No transition for instant drag feedback */
    }

    /* Draggable thumb at end of progress fill */
    .player-progress-thumb {
        position: absolute;
        top: 50%;
        left: 0%;
        transform: translate(-50%, -50%);
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #ffffff;
        border: 2px solid #7367f0;
        box-shadow: 0 2px 6px rgba(0,0,0,0.15);
        pointer-events: auto;
        cursor: pointer;
        z-index: 5;
    }

    .player-progress-thumb:focus {
        outline: none;
        box-shadow: 0 0 0 4px rgba(115,103,240,0.12);
    }

    /* Zoom-side compact buttons (placed next to zoom slider) */
    .zoom-side-buttons {
        display: flex;
        gap: 6px;
        margin-right: 6px;
        align-items: center;
    }

    .zoom-side-buttons .ctrl-btn {
        width: 24px;
        height: 22px;
        font-size: 11px;
        padding: 0;
    }

    .player-seek-container-inline .player-seek-bar::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #7367f0;
        box-shadow: 0 0 0 3px rgba(115,103,240,0.12);
        cursor: pointer;
    }

    .player-time-display-inline {
        font-family: monospace;
        font-size: 12px;
        color: #666;
        min-width: 110px;
        text-align: left;
    }

    /* Timeline container */
    #waveformindex {
        background: #fafafa;
        border: none;
        height: 20px;
        overflow: hidden;
        margin: 0;
        padding: 0;
        line-height: 0;
        display: block;
    }

    #waveformindex wave,
    #waveformindex > div {
        height: 20px !important;
        margin: 0 !important;
        padding: 0 !important;
        line-height: 0 !important;
    }

    #waveformindex canvas {
        vertical-align: bottom !important;
        display: block !important;
    }

    /* Ensure wavesurfer timeline plugin is visible and touches waveform */
    .wavesurfer-timeline {
        font-size: 10px !important;
        color: #333 !important;
        margin: 0 !important;
        padding: 0 !important;
        line-height: 0 !important;
    }

    /* Remove gap between timeline and waveform */
    #waveform {
        margin: 0 !important;
        padding: 0 !important;
        border-top: none !important;
    }

    #waveform wave {
        margin-top: 0 !important;
    }

    /* Scrollbar row */
    .scrollbar-row {
        min-height: 16px;
        border-top: 1px solid #e0e0e0;
    }

    .scrollbar-sidebar {
        background: #fafafa;
    }
    .scrollbar-content {
        background: #f5f5f5;
        padding: 4px 0;
    }

    .h-scrollbar {
        height: 8px;
        background: #ddd;
        border-radius: 4px;
        margin: 0 4px;
    }

    /* =================== REPORT TABLE STYLES =================== */
    /* Wrapper for the custom speaker dropdown in the table */
.speaker-select-wrapper {
    position: relative;
    width: 100%;
}

/* The custom arrow icon for the speaker dropdown */
.speaker-select-wrapper::after {
    content: '▼'; /* You can also use other symbols like '▾' */
    position: absolute;
    top: 50%;
    right: 8px; /* Position from the right edge */
    transform: translateY(-50%); /* Vertical centering */
    font-size: 10px;
    color: #555;
    pointer-events: none; /* Allows clicks to pass through to the select element */
}

/* Modify the existing speaker <select> element */
.speaker-select-cell {
    /* Hides the default browser arrow */
    -webkit-appearance: none;
    appearance: none;

    /* Adds padding on the right to make space for our custom arrow */
    padding-right: 25px !important;
    width: 100%;
}
    #reportpanel {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 200px;
        overflow: hidden;
    }
    .table-row-invalid {
    background-color: #fff0f1 !important; /* A light pink/red to indicate an error */
    border-left: 3px solid #dc3545 !important; /* A strong red left border */
    }
    .reporttable {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .reporttable thead {
    display: table;
    width: 100%; /* Use full width */
    table-layout: fixed;
    background: #f8f9fa;
    flex-shrink: 0;
    /* This ensures the padding we add later is applied correctly */
    box-sizing: border-box;
}

    .reporttable tbody {
        display: block;
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1 1 auto;
    }

    .reporttable thead tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    .reporttable tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    .reporttable th,
    .reporttable td {
        padding: 8px 6px;
        border-bottom: 1px solid #dee2e6;
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .reporttable th:nth-child(1), .reporttable td:nth-child(1) { width: 40px; }
    .reporttable th:nth-child(2), .reporttable td:nth-child(2) { width: 120px; }
    .reporttable th:nth-child(3), .reporttable td:nth-child(3) { width: 70px; }
    .reporttable th:nth-child(4), .reporttable td:nth-child(4) { width: 70px; }
    .reporttable th:nth-child(5), .reporttable td:nth-child(5) { width: 120px; }
    .reporttable th:nth-child(6), .reporttable td:nth-child(6) { width: 100px; }
    .reporttable th:nth-child(7), .reporttable td:nth-child(7) { width: 90px; } /* Language */
    .reporttable th:nth-child(8), .reporttable td:nth-child(8) { width: 90px; } /* Seg.Lang */
    .reporttable th:nth-child(9), .reporttable td:nth-child(9) { width: auto; }  /* TranscriptionData */
    .reporttable th:nth-child(10), .reporttable td:nth-child(10) { width: auto; } /* TranscriptionLatin */
    .reporttable th:nth-child(11), .reporttable td:nth-child(11) { width: 80px; text-align: center; } /* Action */
    .reporttable th:nth-child(12), .reporttable td:nth-child(12) { width: 50px; text-align: center; } /* Visibility */

    .reporttable tbody tr.table-active {
        border-left: 3px solid #7367f0; /* background-color: #e8e4ff; This adds the new red indicator bar */
    }
    .reporttable tbody tr.table-active td:first-child {
        padding-left: 3px; /* Adjusts padding to compensate for the border width */
    }
    /* Custom scrollbar for table */
    .reporttable tbody::-webkit-scrollbar {
        width: 8px;
    }

    .reporttable tbody::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    .reporttable tbody::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
    }

    .reporttable tbody::-webkit-scrollbar-thumb:hover {
        background: #a1a1a1;
    }

    /* Transcription textarea styling */
    .transcription-cell {
        vertical-align: top;
        padding: 4px 6px;
    }

    .transcription-input,
    .transcription-latin-input {
        width: 100%;
        min-height: 60px; /* Enforces minimum height */
        max-height: 120px; 
        font-size: 12px;
        resize: none; /* Disables manual resizing by the user */
        overflow-y: auto; 
        line-height: 1.4;
        padding: 6px 8px;
        border: 1px solid #ced4da;
        border-radius: 4px;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .transcription-input:focus,
    .transcription-latin-input:focus {
        border-color: #7367f0;
        outline: none;
        box-shadow: 0 0 0 2px rgba(115, 103, 240, 0.2); /* Unified focus style */
    }
    .transcription-input.tagged-output-preview,
.transcription-latin-input.tagged-output-preview {
    color: #343a40;                               /* A dark, readable gray color */
    background-color: #f1f3f5;                   /* A very light gray background to indicate read-only */
    font-size: 14px;                               /* Consistent font size */
    cursor: text;                                  /* Allows selecting text for copy-paste */
    opacity: 1 !important;                         /* Ensures text is not faded */
}
    .transcription-input::placeholder,
.transcription-latin-input::placeholder {
    color: #adb5bd; /* A standard light grey for placeholder text */
    font-size: 14px; /* Keep placeholder font size standard */
}
    .transcription-input:disabled:not(.transcription-confirmed),
    .transcription-latin-input:disabled:not(.transcription-confirmed) {
        background-color: #fff !important;
        cursor: not-allowed !important;
        color: #999;
        border-color: #ced4da;
    }

    .transcription-input.transcription-confirmed,
    .transcription-latin-input.transcription-confirmed {
        background-color: #fff !important;
        cursor: default !important;
        color: #333;
        border-color: #ced4da;
    }

    .transcription-input::placeholder {
        color: #adb5bd;
    }

    /* Allow row height to expand with content */
    .reporttable tbody tr {
        height: auto;
        min-height: 44px;
    }

    /* Default cells aligned to top */
    .reporttable td {
        vertical-align: top;
        padding-top: 8px;
    }

    /* Center dropdowns vertically (Primary Type, Loudness columns) */
    .reporttable td:nth-child(5),
    .reporttable td:nth-child(6) {
        vertical-align: middle;
    }

    /* Center ID, Speaker, Start, End, and Action columns as well */
    .reporttable td:nth-child(1),
    .reporttable td:nth-child(2),
    .reporttable td:nth-child(3),
    .reporttable td:nth-child(4),
    .reporttable td:nth-child(8) {
        vertical-align: middle;
    }

    /* Action cell styling */
    .action-cell {
        vertical-align: middle !important;
    }

    .action-cell .btn {
        padding: 2px 6px;
        font-size: 14px;
        line-height: 1;
    }

    .action-cell .btn i {
        font-size: 14px;
    }

    .action-confirm {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
    }

    .action-confirm .btn,
    .action-edit,
    .action-delete {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 4px;
    }

    .action-confirm .btn:hover,
    .action-edit:hover,
    .action-delete:hover {
        background-color: #f0f0f0;
    }
    /* =================== NEW: TAG DRAWER & TOOLTIP STYLES =================== */
.tag-drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 999;
    display: none;
}

.tag-drawer-overlay.active {
    display: block;
}

.tag-drawer {
    position: fixed;
    top: 0;
    right: 0;
    width: 550px; /* <--- NEW, WIDER DRAWER */
    height: 100vh;
    background: #ffffff;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    transform: translateX(550px);
    transition: transform 0.3s ease-in-out;
    overflow-y: auto;
    overflow-x: hidden;
}

.tag-drawer.active {
    transform: translateX(0);
}

.tag-drawer-header {
    background: #7367f0;
    color: white;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.tag-drawer-header h5 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
}

.tag-drawer-close-btn {
    background: transparent;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
}

.tag-drawer-close-btn:hover {
    background-color: rgba(255, 255, 255, 0.15);
    transform: scale(1.1) rotate(90deg);
}

.tag-drawer-content {
    padding: 20px;
    background: linear-gradient(to bottom, #f8f7ff, #ffffff);
}

.tag-drawer-section {
    margin-bottom: 20px;
}

.tag-drawer-section-title {
    font-size: 13px;
    font-weight: 600;
    color: #7367f0;
    text-transform: uppercase;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 2px solid #f0f0f0;
}

.tag-drawer-section-value {
    font-size: 14px;
    color: #333;
    line-height: 1.6;
    word-break: break-word;
    background: #ffffff;
    padding: 15px;
    border-radius: 8px;
    text-align: justify !important;
    border: 1px solid #e0dcfc;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.1);
}

#transcription-display-area:focus {
    outline: none;
}

.annotation-tag {
    position: relative;         /* Stays the same: positions the label relative to this element */
    display: inline-block;      /* NEW: Allows the span to have a top margin */
    margin-top: 22px;           /* NEW: Pushes the highlighted text down to create space for the label above it */
    background-color: #ffe1194D;
    border-radius: 3px;
    padding: 1px 3px;
    cursor: pointer;
    border-top: 2px solid #f58231;
}

/* 2. REPLACE the .tag-label-on-span rule with this */
.tag-label-on-span {
    position: absolute;
    top: -20px;                 /* CHANGE: Precisely positions the label 20px above the span's content */
    left: 0;
    background-color: #4363d8;
    color: white;
    font-size: 11px;
    font-weight: bold;
    padding: 2px 5px;
    border-radius: 3px;
    white-space: nowrap;
    user-select: none;
}

.tag-label-delete {
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    font-family: 'Courier New', Courier, monospace;
}

.tag-label-delete:hover {
    color: #ffdddd;
}
.inline-tag-tooltip {
    position: absolute;
    z-index: 1051;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    width: 250px;
    font-family: sans-serif;
    display: none;
    user-select: none;
}

.inline-tag-tooltip .tooltip-header {
    display: flex;
    justify-content: space-between; /* This pushes the items to opposite ends */
    align-items: center; /* This vertically aligns them */
    padding: 8px;
    border-bottom: 1px solid #f0f0f0;
}

.inline-tag-tooltip .tooltip-action-btn {
    background: #f5f5f5;
    border: 1px solid #ddd;
    color: #555;
    border-radius: 4px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.inline-tag-tooltip .tooltip-delete-btn {
    color: #dc3545; /* A standard red color */
}

.inline-tag-tooltip .tooltip-delete-btn:hover {
    background-color: #f8d7da; /* A light red for the hover state */
    border-color: #f5c6cb;
}
.inline-tag-tooltip .tooltip-close-btn {
    color: #dc3545; /* A standard red color */
}

.inline-tag-tooltip .tooltip-close-btn:hover {
    background-color: #f8d7da; /* A light red for the hover state */
    border-color: #f5c6cb;
}
.inline-tag-tooltip .tooltip-search {
    position: relative;
    padding: 8px;
}

.inline-tag-tooltip .tooltip-search-input {
    width: 100%;
    padding: 6px 30px 6px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.inline-tag-tooltip .tooltip-search .fa-search {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
    color: #888;
}

.inline-tag-tooltip .tooltip-tag-list {
    max-height: 150px;
    overflow-y: auto;
    padding: 0 4px;
}

.inline-tag-tooltip .tooltip-tag-item {
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    border-radius: 4px;
    margin: 4px 0;
}
.inline-tag-tooltip .tooltip-tag-item:hover {
    background-color: #f5f5f5;
}
/* Arrow indicator for items with sub-tags */
.inline-tag-tooltip .submenu-indicator {
    margin-left: auto;
    font-size: 10px;
    color: #888;
    padding: 0 5px;
}

/* The sub-menu popup container */
.sub-tag-tooltip {
    position: absolute;
    top: 50%; /* Position the top edge at the parent's vertical midpoint */
    left: calc(100% + 5px); /* Position to the right of the parent */
    transform: translateY(-50%); /* Pull the menu up by half its own height to center it */
    margin-left: 0;
    z-index: 1052;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    min-width: 200px;
    font-family: sans-serif;
    display: none;
    padding: 4px;
    user-select: none;
}


.inline-tag-tooltip .tag-color-indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 10px;
    flex-shrink: 0;
}

.inline-tag-tooltip .tag-name {
    flex-grow: 1;
    font-size: 14px;
    color: #333;
}

.inline-tag-tooltip .tag-count-badge {
    background-color: #e9ecef;
    color: #495057;
    font-size: 12px;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 10px;
}

.inline-tag-tooltip .tooltip-footer {
    padding: 8px;
    border-top: 1px solid #f0f0f0;
}

.inline-tag-tooltip .add-label-btn {
    width: 100%;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    padding: 8px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    color: #212529;
    text-align: center;
}

.inline-tag-tooltip .add-label-btn:hover {
    background-color: #e2e6ea;
}
/* =================== END OF NEW STYLES =================== */
`));

        function highlightWordAtTime(currentTime) {
            let activeWordLocation = { line: -1, word: -1 };
            if (!descriptor.transcript) return;

            // Find the word where currentTime is between its start and end.
            for (let i = 0; i < descriptor.transcript.length; i++) {
                const line = descriptor.transcript[i];
                if (line.words) {
                    for (let j = 0; j < line.words.length; j++) {
                        const word = line.words[j];
                        // This check will now succeed because 'word.start' and 'word.end' are populated!
                        if (word.start !== null && currentTime >= word.start && currentTime <= word.end) {
                            activeWordLocation = { line: i, word: j };
                            break;
                        }
                    }
                }
                if (activeWordLocation.line !== -1) break;
            }

            // Update the UI only if the highlighted word has changed.
            if (activeWordLocation.line !== currentlyHighlightedWord.line || activeWordLocation.word !== currentlyHighlightedWord.word) {
                // Remove highlight from the old word
                if (currentlyHighlightedWord.line !== -1) {
                    $(`span[data-line-index=${currentlyHighlightedWord.line}][data-word-index=${currentlyHighlightedWord.word}]`).removeClass('highlighted-word');
                }
                // Add highlight to the new word
                if (activeWordLocation.line !== -1) {
                    const $newWord = $(`span[data-line-index=${activeWordLocation.line}][data-word-index=${activeWordLocation.word}]`);
                    $newWord.addClass('highlighted-word');

                    // Auto-scroll the panel to keep the highlighted word in view
                    const $reportPanel = $('#reportpanel');
                    if ($newWord.length && $reportPanel.length) {
                        const wordTop = $newWord.position().top;
                        const panelHeight = $reportPanel.height();
                        const currentScrollTop = $reportPanel.scrollTop();
                        if (wordTop < 0 || wordTop > panelHeight) { // Scroll if word is out of view
                            $reportPanel.stop().animate({ scrollTop: currentScrollTop + wordTop - (panelHeight / 2) }, 200);
                        }
                    }
                }
                currentlyHighlightedWord = activeWordLocation;
            }
        }

        function updatePlayerUI() {
            if (!wavesurfer || !waveReady) return;

            const currentTime = wavesurfer.getCurrentTime();
            const duration = wavesurfer.getDuration();

            // (Your existing code for the time display and progress bar remains here)
            // ...
            const currentTimeFormatted = formatTimeCallback(currentTime);
            const durationFormatted = formatTimeCallback(duration);
            $('#time-display').text(`${currentTimeFormatted} / ${durationFormatted}`);
            if (duration > 0) {
                const percent = (currentTime / duration) * 100;
                $('.player-progress-fill').css('width', percent + '%');
                const $bar = $('.player-progress-bar');
                const $thumb = $bar.find('.player-progress-thumb');
                if ($thumb.length && $bar.length) {
                    const barWidth = $bar.width();
                    const thumbLeft = (percent / 100) * barWidth;
                    $thumb.css('left', (thumbLeft) + 'px');
                }
            }
            // ...

            highlightWordAtTime(currentTime);
            if (userExplicitlySelectedRegion) {
                return; // Exit the function early, preserving the user's selection.
            }
            // --- NEW HIGHLIGHTING LOGIC ---
            let activeRegionId = null;

            // 1. Find which region the cursor is currently inside.
            if (wavesurfer.regions) {
                for (const id in wavesurfer.regions.list) {
                    const region = wavesurfer.regions.list[id];
                    if (currentTime >= region.start && currentTime < region.end) {
                        activeRegionId = id;
                        break;
                    }
                }
            }

            // 2. If the active region has changed, update everything.
            if (activeRegionId !== currentlyActiveRegionId) {
                // Remove highlight from the old table row
                if (currentlyActiveRegionId) {
                    $('#wavereport' + currentlyActiveRegionId).removeClass('table-active');
                }

                // Set the new active region
                currentlyActiveRegionId = activeRegionId;

                // Add highlight to the new table row
                if (currentlyActiveRegionId) {
                    $('#wavereport' + currentlyActiveRegionId).addClass('table-active');
                }

                // Update the waveform colors
                updateAllRegionHighlights();
            }
        }

        // This block is inside the 'tracks' function

wavesurfer.on('ready', () => {
    waveReady = true;
    populateMetadataHeader();

    // Load existing regions and correctly set the global descriptor state
    waveLoadData();

    // --- DEFINITIVE FIX: Reorder operations to prevent the UI state from being overwritten ---

    // 1. Build the UI first. This creates the new toggle in its default "off" state.
    frm.loadingOut();
    wavePanel(); 

    // 2. NOW, find the newly created toggle and set its state from our loaded data.
    const transliterateCheck = $('#transliterate-toggle');
    if (transliterateCheck.length) {
        // Read the state directly from the main descriptor object.
        const shouldEnable = descriptor.isTransliterationEnabled === true;
        
        console.log('DEBUG UI: Applying final toggle state:', shouldEnable);
        
        transliterateCheck.prop('checked', shouldEnable);
        // Trigger the change handler to ensure the table columns show/hide correctly.
        transliterateCheck.trigger('change');
    }
    // --- END OF FIX ---

    // Set a consistent default state on load/refresh
    if (wavesurfer) {
        wavesurfer.setCurrentTime(0);
    }
    
    // Finish setting up the rest of the UI
    waveZoomUpdate();
    updatePlayerUI(); // This now correctly reflects the state at time 0
    setHeight();
    $(window).on('resize', setHeight);
});

        wavesurfer.on('audioprocess', updatePlayerUI); // Syncs UI during playback.
        wavesurfer.on('seek', (progress) => {
            updatePlayerUI();

            const scrollableWave = $('#waveform > wave')[0]; // The scrollable element
            if (scrollableWave) {
                const totalWidth = scrollableWave.scrollWidth;
                const viewportWidth = scrollableWave.clientWidth;

                // 1. Calculate the target pixel position based on progress (0.0 to 1.0)
                const targetPixel = totalWidth * progress;

                // 2. Calculate the ideal scroll position to center the target pixel
                let newScrollLeft = targetPixel - (viewportWidth / 2);

                // 3. Clamp the value to prevent scrolling past the boundaries
                const maxScroll = totalWidth - viewportWidth;
                newScrollLeft = Math.max(0, newScrollLeft);       // Don't scroll left of the start
                newScrollLeft = Math.min(maxScroll, newScrollLeft); // Don't scroll right of the end

                // 4. Apply the final, corrected scroll position
                scrollableWave.scrollLeft = newScrollLeft;
            }
            // --- END OF DEFINITIVE SCROLLING FIX ---
        });

        wavesurfer.on('play', () => {
            $('#play-pause-btn i').removeClass('fa-play').addClass('fa-pause');
        });
        wavesurfer.on('pause', () => {
            $('#play-pause-btn i').removeClass('fa-pause').addClass('fa-play');
            
            // --- FIX: Deactivate the selection lock when the user pauses. ---
            userExplicitlySelectedRegion = false;
        });

        // This is the new, corrected code
        wavesurfer.on('finish', () => {
            $('#play-pause-btn i').removeClass('fa-pause').addClass('fa-play');
            $('.player-seek-bar').val(1000);

            // --- FIX: Deactivate the selection lock when playback finishes. ---
            userExplicitlySelectedRegion = false;

            const scrollableWave = $('#waveform > div')[0];
            if (scrollableWave) {
                scrollableWave.scrollLeft = scrollableWave.scrollWidth;
            }
        });
        wavesurfer.on('error', (err) => console.error('WaveSurfer error:', err));
        // Dragging support for the progress thumb (mouse + touch)
        (function () {
            let dragging = false;
            let lastPos = 0;

            function updateUIOnly(e, $bar) {
                const pageX = (e.touches && e.touches.length) ? e.touches[0].pageX : e.pageX;
                const barLeft = $bar.offset().left;
                const barWidth = $bar.width();
                let pos = (pageX - barLeft) / barWidth;
                pos = Math.max(0, Math.min(1, pos));
                lastPos = pos;
                // Update UI instantly without calling wavesurfer (faster)
                const percent = pos * 100;
                $bar.find('.player-progress-fill').css('width', percent + '%');
                $bar.find('.player-progress-thumb').css('left', (pos * barWidth) + 'px');
            }

            function finishSeek() {
                // Actually seek wavesurfer only on release
                if (wavesurfer && typeof wavesurfer.seekTo === 'function') {
                    wavesurfer.seekTo(lastPos);
                }
                dragging = false;
                $(document).off('.playerProgress');
            }

            // Start drag when mouse down on thumb
            $('.waveinterface').on('mousedown', '.player-progress-thumb', function (ev) {
                if (window.descriptor.blockEdit) return showLockAlert();
                ev.preventDefault();
                ev.stopPropagation();
                dragging = true;
                const $bar = $(this).closest('.player-progress-bar');
                $(document).on('mousemove.playerProgress', function (e) { updateUIOnly(e, $bar); });
                $(document).on('mouseup.playerProgress', finishSeek);
            });

            // Touch support
            $('.waveinterface').on('touchstart', '.player-progress-thumb', function (ev) {
                if (window.descriptor.blockEdit) return showLockAlert();
                ev.preventDefault();
                ev.stopPropagation();
                dragging = true;
                const $bar = $(this).closest('.player-progress-bar');
                $(document).on('touchmove.playerProgress', function (e) { updateUIOnly(e, $bar); });
                $(document).on('touchend.playerProgress touchcancel.playerProgress', finishSeek);
            });

            // Also allow dragging anywhere on the bar (not just thumb)
            $('.waveinterface').on('mousedown', '.player-progress-bar', function (ev) {
                if ($(ev.target).hasClass('player-progress-thumb')) return; // handled above
                if (window.descriptor.blockEdit) return showLockAlert();
                ev.preventDefault();
                dragging = true;
                const $bar = $(this);
                updateUIOnly(ev, $bar);
                $(document).on('mousemove.playerProgress', function (e) { updateUIOnly(e, $bar); });
                $(document).on('mouseup.playerProgress', finishSeek);
            });

            // Keyboard support: left/right arrows on thumb
            $('.waveinterface').on('keydown', '.player-progress-thumb', function (e) {
                const $bar = $(this).closest('.player-progress-bar');
                const barWidth = $bar.width();
                const duration = (wavesurfer && wavesurfer.getDuration) ? wavesurfer.getDuration() : 0;
                if (!duration) return;
                const stepSec = Math.max(0.5, duration * 0.01); // 1% step or 0.5s
                if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    wavesurfer.skip(-stepSec);
                    updatePlayerUI();
                } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    wavesurfer.skip(stepSec);
                    updatePlayerUI();
                }
            });
        })();

        // Handle clicks on transcribed words
        $(document).on('click', '.transcript-word', function () {
            const start = parseFloat($(this).data('start'));
            if (!isNaN(start)) wavesurfer.setCurrentTime(start);
        });

        $(document.body).off('keydown').on('keydown', function (e) {
            // Ignore shortcuts if the user is typing in an input/textarea field
            if ($(e.target).is('input, textarea')) return;

            const isPlaybackKey = [32, 37, 39, 38, 40].includes(e.keyCode);
            if (isPlaybackKey && window.descriptor.blockEdit) {
                e.preventDefault();
                return showLockAlert();
            }
            switch (e.keyCode) {
                // --- Playback Controls ---
                case 32: // Spacebar
                    e.preventDefault();
                    wavesurfer.playPause();
                    break;
                case 37: // Left Arrow
                    e.preventDefault();
                    wavesurfer.skipBackward(1);
                    break;
                case 39: // Right Arrow
                    e.preventDefault();
                    wavesurfer.skipForward(1);
                    break;
                case 38: // Up Arrow
                    e.preventDefault();
                    wavesurfer.skipForward(10);
                    break;
                case 40: // Down Arrow
                    e.preventDefault();
                    wavesurfer.skipBackward(10);
                    break;

                // --- FIX START: New Row Deletion Logic ---
                case 46: // Delete key
                case 8:  // Backspace key
                    // 1. Find the currently selected row in the table.
                    const $selectedRow = $('.reporttable tbody tr.table-active');

                    // 2. If a row is selected, proceed with deletion.
                    if ($selectedRow.length > 0) {
                        e.preventDefault(); // Prevent default browser actions (e.g., backspace navigating back).

                        // 3. Get the region ID from the row's ID attribute.
                        const rowId = $selectedRow.attr('id');
                        const regionId = rowId ? rowId.replace('wavereport', '') : null;

                        // 4. Find the corresponding WaveSurfer region object.
                        const regionToDelete = regionId ? window.wavesurfer.regions.list[regionId] : null;

                        if (regionToDelete) {
                            // 5. Use the exact same confirmation popup as the trash icon.
                            myAlert(
                                'Confirm Deletion',
                                'Are you sure you want to delete this segment?',
                                '*Delete',
                                function () {
                                    // This function runs if the user clicks "Delete".
                                    regionToDelete.remove();
                                    window.waveReport(); // Refresh the table.
                                    changed();           // Mark changes for auto-save.
                                    myAlertClose();      // Close the confirmation popup.
                                },
                                'Cancel',
                                function () {
                                    // This function runs if the user clicks "Cancel".
                                    myAlertClose(); // Just close the popup.
                                }
                            );
                        }
                    }
                    break; // End of delete case
                // --- FIX END ---
            }
        });

        // --- 7. LOAD MEDIA ---
        video.src = tagData.audioSource || tagData.videoSource;
        wavesurfer.load(video);

        return this;
    }, 0);
}

function showVersion(s) {
    descriptor.version = s;
    $('#version').remove();
    $('#t_right').prepend(
        $('<span>')
            .addClass('version')
            .prop('id', 'version')
            .html('Version: ' + s)
    );
}

function checkBox(div, label, checked, callback) {
    function ck(bool, label) {
        var rck = bool ? 'fa-check-square-o' : 'fa-square-o';
        return '<i class="fa ' + rck + ' check-box-icon"></i> ' + label;
    }
    var cbox = $('<div>').prop('field', 'check-' + label).addClass('radio-list').addClass('field');
    cbox.html('<div class="err"></div>');

    var sopt = $('<span>').addClass('radio-list-option').html(ck(checked, label)).prop('checked', checked).on('click', function () {
        var checked = $(this).prop('checked') || false;
        checked = !checked;
        $(this).prop('checked', checked)
        $(this).html(ck(checked, label));
        if (callback) callback(checked);
    })
    cbox.append(sopt);
    div.html('').append(cbox)
    console.log('checkbox', label, checked);
}


function radioList(div, iattrs, opt) {
    var radio = $('<div>').prop('field', 'radio-' + iattrs.label).addClass('radio-list').addClass('field');
    console.log('radioList', iattrs, opt);
    function ck(bool) {
        var rck = bool ? 'fa-check-circle-o' : 'fa-circle-o';
        return '<i class="fa ' + rck + '"></i>';
    }
    if (!opt) opt = {};
    var optid = iattrs.label;
    function options() {
        radio.html('<div class="err"></div>');
        if (!iattrs.noLabel) radio.append('<span class="radio-list-title">' + iattrs.label + ':<span>');
        iattrs.options.forEach(o => {
            var sopt = $('<span>').addClass('radio-list-option').html(ck(o == opt[optid]) + ' ' + o).prop('optid', o).on('click', function () {
                opt[optid] = $(this).prop('optid');
                console.log('optid', optid, 'v', opt);
                options();
            })
            radio.append(sopt);
        })
    }
    options();
    div.append(radio);
}


function listAttributes(div, iattrs, attributes, title) {
    div.html('');
    div.addClass('text-attrs');
    if (iattrs) {
        var choose = $('<DIV>');
        // choose.append($('<DIV>').addClass('cchoosetitle').addClass('cchooselabel').html('<h5>'+title+'</h5>'));
        choose.append($('<DIV>').addClass('cchoosetitle').addClass('cchooselabel'));
        choose.css({ width: px(div.width()) })
        div.append(choose);

        iattrs.forEach(function (a) {
            a.optional = bool(a.optional);
            a.allowNew = bool(a.allowNew);
            if (!(a.label in attributes) && !a.optional) attributes[a.label] = null;
            var label = a.label;
            // if( !a.optional ) label = '*'+label;
            var aline = $('<div>').html('<div class="doc-attributes">' + label + '</div>');
            var select = $('<select class="mmdb-select mmd-form iselect">');
            select.prop('id', 'select' + label);
            aline.append(select);
            if (!a.options) a.options = ["no", "yes"];
            var placeholder = a.placeholder || '(select)';
            select.append($('<option>').prop('value', '').html(placeholder));
            var opts = {};
            if (attributes[a.label] && a.options.indexOf(attributes[a.label]) == -1)
                a.options.push(attributes[a.label])
            a.options.forEach(function (aopt, idx) {
                opts[aopt] = 1;
                select.append($('<option>').prop('value', aopt).html(aopt));
            });
            // console.log('ATTR', attributes[a.label], a.options );
            if (a.allowNew) {
                select.append($('<option>').prop('value', '_new').html('(Add new ' + a.label + ')'));
            }
            select.val(attributes[a.label])
            select.on('change', function () {
                // selectStyle(select);
                var selectedValue = select.val();
                if (selectedValue === '') selectedValue = null;
                attributes[a.label] = selectedValue;
                if (selectedValue !== '_new') text.hide();
                else {
                    text.show();
                    text.focus();
                }
                changed();
            });
            var text = $('<INPUT TYPE="text">').prop('id', 'selectText' + a.label).addClass('iselect-text').hide();
            text.on('keyup', function (ev) {
                if (ev.keyCode == 13) {
                    textSave();
                }
            });
            text.on('change', textSave)
            function textSave() {
                var selectedValue = text.val().trim();
                if (selectedValue === '') return myAlert('Value Required', 'Please select the new value for attribute "' + a.label + '"');
                text.hide();
                if (!(val in opts)) {
                    a.options.push(val);
                }
                attributes[a.label] = val;
                listAttributes(div, iattrs, attributes);
            }
            aline.append(text);
            choose.append(aline);
        });
    }
    // div.append( $('<br><h5>Aditional Notes</h5>') );
    // var addNotes = $('<TEXTAREA>').addClass('inote-text');
    var addNotes = descriptor.reviewMode ? $('#reviewer_notes') : $('#annotator_notes');
    addNotes.val(attributes["Aditional Notes"] || "");
    addNotes.on('change', updateNotes).on('blur', updateNotes);
    let m = descriptor.messages || [];
    if (m.length && m[m.length - 1][1] == addNotes.val()) addNotes.val('');
    function updateNotes() { attributes["Aditional Notes"] = $(this).val(); changed() };
    // div.append( addNotes );
}

var changed = function () { console.log('changed', Date.now()) };
var myAlert = function (title, body, btn, callback, btn2, callback2, btn3, callback3) {
    $('.modal-title').html(title);
    var modal = window.$("#myModal");
    if (typeof (body) == 'string') $('.modal-body').html(body);
    else $('.modal-body').html('').append(body);
    $('.waveinterface').css('z-index', 0);
    modal.modal({
        backdrop: 'static',
        keyboard: false,
    })
    modal.find(".myclose").css({ position: 'absolute', right: px(10), top: px(0) }).hide();
    modal.find(".btn").hide();
    modal.find('.btn-primary').removeClass('btn-primary');
    modal.find('.btn-secondary').removeClass('btn-secondary');
    modal.find('.btn-danger').removeClass('btn-danger');

    function setButton(id, label, callback) {
        var bid = '#modal-close' + (id || '');
        var but = modal.find(bid);
        if (!label) label = '';
        var isDanger = label.match(/^\*/);
        var isPrimary = label.match(/^\^/);
        if (isPrimary) but.addClass('btn-primary')
        else if (isDanger) but.addClass('btn-danger')
        else but.addClass('btn-secondary');
        label = label.replace(/^[\^\*]/, '');
        but.html(label);
        if (label) but.show();
        else but.hide();
        but.off('click');
        if (callback) but.on('click', callback);
    }
    if (!btn) btn = 'Ok';
    setButton('', btn, callback);
    setButton(2, btn2, callback2);
    setButton(3, btn3, callback3);
}
function restoreWaveRegionVisibility() {
    if (tempVisibleRegion && originalEyeState) {
        console.log('Restoring visibility for region:', originalEyeState.regionId, 'Original state was visible:', originalEyeState.wasVisible);
        if (originalEyeState.wasVisible) {
            originalEyeState.eyeElement.removeClass('fa-eye fa-eye-slash').addClass('fa-eye');

            if (tempVisibleRegion.element) {
                tempVisibleRegion.element.style.display = 'block';
                tempVisibleRegion.element.style.visibility = 'visible';
                tempVisibleRegion.element.style.opacity = '1';
            }

            $('div[data-id="' + tempVisibleRegion.id + '"]').css({
                'display': 'block',
                'visibility': 'visible',
                'opacity': '1'
            });

            if (tempVisibleRegion.wrapper) {
                tempVisibleRegion.wrapper.style.display = 'block';
            }

            tempVisibleRegion.data.visible = true;
        } else {
            originalEyeState.eyeElement.removeClass('fa-eye fa-eye-slash').addClass('fa-eye-slash');

            if (tempVisibleRegion.element) {
                tempVisibleRegion.element.style.display = 'none';
                tempVisibleRegion.element.style.visibility = 'hidden';
                tempVisibleRegion.element.style.opacity = '0';
            }

            $('div[data-id="' + tempVisibleRegion.id + '"]').css({
                'display': 'none',
                'visibility': 'hidden',
                'opacity': '0'
            });

            if (tempVisibleRegion.wrapper) {
                tempVisibleRegion.wrapper.style.display = 'none';
            }

            tempVisibleRegion.data.visible = false;
        }

        tempVisibleRegion = null;
        originalEyeState = null;
    }
}


var myAlertClose = function (callback) {
    function onModalHidden(ev) {
        $('#myModal').off('hidden.bs.modal', onModalHidden);
        restoreWaveRegionVisibility();
        $('.waveinterface').css('z-index', '');
        if (callback) {
            callback(ev);
        }
    }

    $('#myModal').on('hidden.bs.modal', onModalHidden);

    setTimeout(function () {
        $('#myModal').modal('hide');
    }, 10);
}

function saveClipboard(txt) {
    var input = $('<textarea>').val(txt).css({ position: 'absolute', top: px(-10000), left: px(-100000) });
    $(document.body).append(input);
    input.select();
    document.execCommand("copy");
    setTimeout(function () {
        input.remove();
    }, 100);
}
/**
 * Generates a plain text file from the current transcript data
 * and triggers a download in the browser.
 */
function exportDraftText() {
    // 1. Check if there is transcript data available.
    if (!window.descriptor || !window.descriptor.transcript || window.descriptor.transcript.length === 0) {
        // Use the existing alert function for a consistent UI.
        myAlert('Export Error', 'There is no transcript data to export.');
        return;
    }

    // 2. Map the structured transcript data back to the "speaker: dialogue" string format.
    // This uses the cleaned and processed text from the right-side panel.
    const draftContent = window.descriptor.transcript.map(line => {
        return `${line.speaker}: ${line.dialogue}`;
    }).join('\n');

    // 3. Create a Blob (a file-like object) from the text content.
    const blob = new Blob([draftContent], { type: 'text/plain;charset=utf-8' });

    // 4. Create a temporary link element to trigger the file download.
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'exported_transcript_draft.txt'; // Set the default filename.

    // 5. Programmatically click the link to start the download, then clean up.
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href); // Free up memory.
}
// PASTE THE NEW FUNCTIONS HERE:
/**
* Converts seconds into HH:MM:SS:FF timecode format.
* @param {number} secs - The time in seconds.
* @param {number} [fps=30] - Frames per second for the calculation.
* @returns {string} The formatted timecode.
*/
function ftime(secs, fps = 30) {
    if (typeof secs !== 'number' || isNaN(secs)) {
        return '00:00:00:00';
    }

    // --- FIX: This new implementation avoids floating-point errors from fractional seconds ---

    // 1. Convert total seconds to total frames, rounding to the nearest whole frame.
    // This is the key step to correct for floating-point inaccuracies from previous calculations.
    const totalFrames = Math.round(secs * fps);

    // 2. Calculate HH:MM:SS:FF from the integer-based total frames. This is more stable.
    const hh = Math.floor(totalFrames / (3600 * fps));
    const mm = Math.floor((totalFrames % (3600 * fps)) / (60 * fps));
    const ss = Math.floor((totalFrames % (60 * fps)) / fps);
    const ff = totalFrames % fps;

    return [hh, mm, ss, ff]
        .map(v => v.toString().padStart(2, '0'))
        .join(':');
}
/**
 * Formats seconds into a string with 3 decimal places for display.
 * @param {number} seconds - The time in seconds.
 * @returns {string} The formatted time string (e.g., "6.543").
 */
function formatTimeWithMilliseconds(seconds) {
    if (typeof seconds !== 'number' || isNaN(seconds)) {
        return '0.000';
    }
    return seconds.toFixed(3);
}
/**
 * Converts HH:MM:SS:FF timecode format back to seconds.
 * @param {string} timecode - The timecode string.
 * @param {number} [fps=30] - Frames per second for the calculation.
 * @returns {number} The time in seconds.
 */
function timecodeToSeconds(timecode, fps = 30) {
    if (typeof timecode !== 'string' || !timecode.includes(':')) {
        return parseFloat(timecode) || 0; // Return if it's already a number
    }
    const parts = timecode.split(':').map(Number);
    if (parts.length === 4) {
        const [hh, mm, ss, ff] = parts;
        return hh * 3600 + mm * 60 + ss + (ff / fps);
    }
    return 0;
}

// TAXONOMY MODE: New wrapper function to choose the export method.
function exportData(nocheck) {
    // This is the switch. It checks if Taxonomy mode is on.
    if (window.descriptor.Taxonomy) {
        // If yes, call the new, advanced export function.
        return exportDataWithTaxonomy(nocheck);
    } else {
        // If no, call the original function we just renamed.
        return exportDataSimple(nocheck);
    }
}
// ADL

// ===== START: REPLACE THIS ENTIRE FUNCTION =====
function exportDataSimple(nocheck) {
    var ret = {};

    if (declined) {
        ret.taskDeclined = true;
        ret.declineReason = declineReason;
    }

    var streams = {};
    var activeMode = window.currentMode || descriptor.currentMode;

    if (activeMode && activeMode.name) {
        streams[activeMode.name] = [];

        if (window.wavesurfer && window.wavesurfer.regions) {
            Object.values(window.wavesurfer.regions.list).forEach(r => {
                streams[activeMode.name].push({
                    start_time: ftime(r.start),
                    end_time: ftime(r.end),
                    tag: r.data.tag || "",
                    primaryType: r.data.tone || "",
                    loudnessLevel: r.data.loudness || "",
                    language: r.data.language || "",
                    segmentLanguage: r.data.segmentLanguage || "",
                    notes: r.data.notes || "",
                    transcription: r.data.transcription || "",
                    transcriptionConfirmed: r.data.transcriptionConfirmed || false,
                    transcriptionLatin: r.data.transcriptionLatin || "",
                    annotatedHtml: r.data.annotatedHtml || "",
                    annotatedHtmlTransliteration: r.data.annotatedHtmlTransliteration || "",
                    _transcriptionRules: activeMode['Transcription Inline'] || []
                });
            });
        }

        if (streams[activeMode.name].length > 0) {
            streams[activeMode.name].sort((a, b) => (a.start_time > b.start_time) ? 1 : -1);
        }
    }

    // --- DEFINITIVE FIX: Attach the flag directly to the 'streams' object ---
    // This matches the data structure you provided.
    streams.isTransliterationEnabled = descriptor.isTransliterationEnabled || false;

    ret.streams = streams;

    ['videoSource', 'audioSource', 'DRMURL', 'DRMServerURL', 'mediaAttributes'].forEach(a => {
        if (tagData[a] !== undefined && tagData[a] !== null) {
            ret[a] = clone(tagData[a]);
        }
    });

    ret.jobStart = descriptor.jobStart;
    ret.sessionTime = (getsec() - descriptor.sessionStart);
    ret.elapsedTime = descriptor.elapsedTime + ret.sessionTime;
    ret.tsSeconds = true;
    ret.updateTime = getsec();

    if (descriptor.metadata) {
        ret.metadata = clone(descriptor.metadata);
    }
    
    // The old top-level property is now removed to avoid confusion.
    
    return ret;
}
// ===== END: REPLACE THIS ENTIRE FUNCTION =====

function exportDataWithTaxonomy(nocheck) {
    var ret = {};
    var check = nocheck || declined ? false : true;

    // --- Decline Logic ---
    if (declined) { /*... same decline logic as original ...*/ }

    // --- Reviewer Logic ---
    if (descriptor.reviewMode) { /*... same review logic as original ...*/ }
    if ($('#annotator_notes').val().trim() > '') { /*... same notes logic as original ...*/ }

    // --- Required Attributes Check ---
    if (tagData.attributes) { /*... same attributes check as original ...*/ }

    // --- Annotation Data Collection (Taxonomy Version) ---
    var ranges = [];
    for (var k in wavesurfer.regions.list) {
        var r = wavesurfer.regions.list[k];
        if (!r.data || !r.data.track) continue;
        var notes = r.data.notes || (window.regionNotes && window.regionNotes[k]) || '';

        // This is a placeholder for your actual taxonomy data lookup.
        // Since code 1 doesn't have `window.tagData_Global`, we'll leave it as a placeholder.
        var matchedTag = null;

        ranges.push({
            id: k, start: r.start, end: r.end, tag: r.data.tag || "", text: r.data.text || "",
            confidence: r.data.confidence || 1, track: r.data.track, notes: notes,
            mode: r.data.mode !== undefined ? r.data.mode : 0, // Include mode information
            TagCode: matchedTag ? matchedTag.TagCode : "-", TagTree: matchedTag ? matchedTag.TagTree : "-"
        });
    }
    ranges.sort((a, b) => a.start - b.start);

    // --- Prepare Streams for Export (Taxonomy Version) ---
    if (!tagData.streams) tagData.streams = {};
    if (currentMode && currentMode.name) {
        tagData.streams[currentMode.name] = [];
        for (var r of ranges) {
            tagData.streams[currentMode.name].push({
                start_time: ftime(r.start),
                end_time: ftime(r.end),
                tag_name: r.text,
                tag_code: r.TagCode,  // Taxonomy-specific field
                tag_tree: r.TagTree,  // Taxonomy-specific field
                notes: r.notes,
                mode: r.mode !== undefined ? r.mode : 0 // Include mode in export
            });
        }
    }

    // --- Final Validation and Data Packaging ---
    if (check) { /*... same validation logic as original ...*/ }

    ['videoSource', 'audioSource', 'DRMURL', 'DRMServerURL', 'streams', 'mediaAttributes'].forEach(a => {
        if (tagData[a]) ret[a] = clone(tagData[a]);
    });

    ret.jobStart = descriptor.jobStart;
    ret.sessionTime = (getsec() - descriptor.sessionStart);
    ret.elapsedTime = descriptor.elapsedTime + ret.sessionTime;
    ret.tsSeconds = true;
    ret.updateTime = getsec();
    ret.metadata = descriptor.metadata;
    
    // --- PERSISTENCE FIX: Save transliteration toggle state to export ---
    ret.isTransliterationEnabled = descriptor.isTransliterationEnabled || false;
    
    return ret;
}

function setHierarchy() {
    var cid = 1000;
    $('.hierarchy').html('<div class="dropdown hierarchy-select" id="hierarchy-classification"><button type="button" class="btn btn-secondary dropdown-toggle" id="example-one-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button><div class="dropdown-menu" aria-labelledby="example-one-button"><div class="hs-searchbox"><input type="text" class="form-control" autocomplete="off"></div><div class="hs-menu-inner"></div></div><input class="d-none" name="example_one" readonly="readonly" aria-hidden="true" type="text"/></div>');
    var clf = $('#hierarchy-classification');
    clf.hierarchySelect({
        width: '100%',
        resetSearchOnSelection: true,
        onChange: change,
        // onHide: hidden,
        // onShow: shown,
    });
    clf.find('button').on('click', function () {
        clf.find('.active').removeClass('active');
    })
    var hinst = clf.prop('instance');
    // clf.find('button').html(descriptor.buttonLabel);
    function setAddLabel() {
        clf.find('button').html('Add Track');
    }
    setAddLabel();
    function change(id) {
        // clf.find('button').html('Add Other Skills');
        // clf.find('button').html('Close');
        // addTag(id);
        // hinst.noToggle();
        // setTimeout( function(){ hinst.noToggle = false}, 1 )
        // hinst.dropDown();
        // setTimeout( function(){hinst.dropDown()}, 1 );
        window.trackObj.setTrack(id);
        console.log('change', id);
        setAddLabel();
    }
    function hidden(inst) {
        console.log('hidden');
        // inst.$button.html(descriptor.buttonLabelExtra)
        // hinst.$searchbox.val('').trigger('propertychange');
        // $('#tags').show();
    }
    function shown(inst) {
        console.log('shown', inst);
        // inst.$button.html('Close')
        // $('#tags').hide();
    }
    var opts = clf.find('.hs-menu-inner');
    function addOpt(path, leaf) {
        // console.log( 'addOpt', path.join('/'), leaf )
        var tid = path.join(' / ');
        // idsFromString[tid] = id;
        // classificationIds[tid] = {path:path, level:level, text:text};
        // // var mydisabled = level == 1 || text == '-';
        // var mydisabled = text == '-';
        // // var oclass = 'dropdown-item tag-level'+level+ ' tag-parent-'+parent;
        // // if( mydisabled ) oclass += ' mydisabled';
        // // var otxt = '<a class="'+oclass+'" id="hid'+id+'" "data-value"="'+tid+'" "data-level"="'+level+'" href="#"></a>';
        // // console.log( otxt );
        // // console.log( 'addOpt', text, level, path, mydisabled, id, parent );
        //
        var text = path.join('/');
        var level = path.length;
        var opt = $('<a class="dropdown-item" href="#">');
        opt.html(text).attr({
            'data-value': tid,
            'data-level': path.length,
        });
        if (!leaf) opt.addClass('disabled').addClass('node');
        opt.prop('id', 'hid' + tid)
        opt.addClass('tag-level' + level);
        opt.addClass('tag-hierarchy');
        // if( !leaf ) opt.addClass('mydisabled');
        opts.append(opt);
        opt.css({ display: 'block' })
    }
    function tree(n, path) {
        console.log('tree', n, path);
        if (isobj(n)) {
            addOpt(path, 0);
            for (var k in n) {
                path.push(k);
                tree(n[k], path)
                path.pop();
            }
        }
        else if (isarray(n)) {
            addOpt(path, 0);
            for (var i of n) {
                path.push(i);
                addOpt(path, 1);
                path.pop();
            }
        }
        else if (isstring(n)) {
            path.push(n);
            addOpt(path, 1);
            path.pop();
        }
        // var level = path.length+1;
        // var keys = Object.keys(n);
        // keys.sort();
        // for( var i = 0 ; i < keys.length ; i++ )
        // {
        //     var s = keys[i];
        //     // console.log( 's', s )
        //     var isleaf = ('_value_' in n[s]);
        //     if( isleaf )
        //     {
        //         ftext = n[s]._value_.text;
        //         if( n[s]._value_.alias && n[s]._value_.alias.length > 0 )
        //             ftext += '<span class="alias">'+n[s]._value_.alias+'</span>';
        //         fpath = clone(n[s]._value_.path);
        //         addOpt( ftext, level, fpath, cid++, parent );
        //     }
        //     else {
        //         text = s;
        //         if( text != '-' ) text = beautify(text);
        //         npath = clone(path);
        //         npath.push(s);
        //         var nodeId = cid++;
        //         addOpt( text, level, npath, nodeId, parent );
        //         tree( n[s], npath, nodeId );
        //     }
        // }
    }
    opts.html('');
    console.log('treeStart');
    // console.log( 'hierarchy', hierarchy )
    tree(descriptor.hierarchy, []);
    console.log('treeEnd');
    $('.dropdown-item').hide();
    $('.tag-hierarchy').show();
}


function modal(title, body, btnTxt, callback) {
    if (!btnTxt) btnTxt = 'Ok';
    return myAlert(title, body, btnTxt, callback);

}

function modalWait(callback) {
    $('#myModal').on('hidden.bs.modal', function (ev) {
        $('#myModal').off('hidden.bs.modal');
        callback(ev);
    });
}


$('.main').hide();

var totalModes = 0;
window.totalModes = totalModes;
/**
 * Populates the .media-metadata element with data from the descriptor.
 * This function is adapted from the working logic in code 2.
 */
function populateMetadataHeader() {
    // 1. Safely merge metadata from both possible locations into a new object.
    const mergedMetadata = {
        ...(descriptor.media && descriptor.media.metadata ? descriptor.media.metadata : {}),
        ...(descriptor.metadata || {})
    };

    // 2. Only proceed if we found any metadata to display.
    if (Object.keys(mergedMetadata).length > 0) {
        // 3. Find the target HTML element that is already on the page.
        const targetElement = $('.media-metadata');

        // 4. Check if the element exists before trying to populate it.
        if (targetElement.length > 0) {
            // Build the display string: "<b>Key:</b> Value&nbsp;&nbsp;&nbsp;<b>Key2:</b> Value2"
            const outputHtml = Object.entries(mergedMetadata)
                .map(([key, value]) => `<b>${key}:</b> ${value}`)
                .join('&nbsp;&nbsp;&nbsp;&nbsp;');

            // Set the content of the target element.
            targetElement.html(outputHtml);

            // Add the "click-to-copy" functionality from the reference code.
            targetElement.attr('title', 'Click to copy full metadata')
                .off('click')
                .on('click', function () {
                    const copyText = JSON.stringify(mergedMetadata, null, 2);
                    saveClipboard(copyText);
                    myAlert('Metadata Copied', 'The full metadata has been copied to your clipboard.');
                });
        } else {
            // This warning is helpful for debugging if the HTML is missing the target element.
            console.warn("Metadata target element '.media-metadata' not found in the DOM.");
        }
    }
}
// =============================================================================
// GLOBAL HELPER FUNCTIONS (BEFORE function init)
// =============================================================================

function setupTranscriptionImport() {
    // --- Hiding Import/Export/Align/Add for Segmentation Mode ---
    const buttonContainer = $('<div class="transcript-controls-container mb-2" style="display:none;"></div>');

    // Create hidden elements to preserve references
    const importButton = $('<div class="action-btn" id="import-draft-btn" style="display:none;"></div>');
    const exportButton = $('<div class="action-btn" id="export-draft-btn" style="display:none;"></div>');
    const alignButton = $('<button id="align-btn" style="display:none;"></button>');
    const addRowButton = $('<div class="action-btn" id="add-row-btn" style="display:none;"></div>');
    const fileInput = $('<input type="file" accept=".txt" style="display: none;" id="draft-file-input">');

    buttonContainer.append(importButton, exportButton, alignButton, addRowButton);
    $('#reportpanel').before(buttonContainer, fileInput);
}
/**
 * Adds a text label on top of a waveform region.
 * @param {object} region The WaveSurfer region object.
 * @param {string} text The text to display on the label.
 */
function waveRegionText(region, text) {
    if (!region || !region.element) return;

    // Remove any existing label first to prevent duplicates on update
    $(region.element).find('.waveform-region-label').remove();

    // Do not add a label if the text is empty
    if (!text) return;

    // Create the new label element
    const label = $('<div>')
        .addClass('waveform-region-label unselectable')
        .text(text);

    // Append the new label to the region's visual element
    $(region.element).append(label);
}
// =============================================================================
// --- NEW, ISOLATED FEATURE: INLINE TRANSCRIPTION TAGGING ---
// This entire block is self-contained and only interacts with the UI
// via the openTagDrawer function, ensuring no impact on other features.
// =============================================================================

// REPLACE your old function with this new one
function createInlineTagTooltip() {
    // Exit if the tooltip already exists to prevent duplicates
    if ($('#inline-tag-tooltip').length > 0) {
        return;
    }

    // 1. Create the main tooltip container with jQuery and hide it immediately.
    // This solves the loading glitch.
    const $tooltip = $('<div id="inline-tag-tooltip" class="inline-tag-tooltip"></div>').hide();

    // 2. Create the header with its buttons
    const $header = $(`
        <div class="tooltip-header">
            <button class="tooltip-action-btn tooltip-delete-btn" title="Delete Tag"><i class="fa fa-trash"></i></button>
            <button class="tooltip-action-btn tooltip-close-btn" title="Close"><i class="fa fa-times"></i></button>
        </div>
    `);

    // 3. Create the search section
    const $search = $(`
        <div class="tooltip-search">
            <input type="text" placeholder="Search" class="tooltip-search-input">
            <i class="fa fa-search"></i>
        </div>
    `);

    // 4. Create the containers for the tag list and footer
    const $tagList = $('<div class="tooltip-tag-list"></div>');
    const $footer = $('<div class="tooltip-footer pb-5"></div>');

    // 5. Append all the parts to the main container.
    // This guarantees the content is never missing.
    $tooltip.append($header, $search, $tagList, $footer);

    // 6. Append the fully constructed (but still hidden) tooltip to the page body
    $('body').append($tooltip);

    // 7. Store the reference and attach all the necessary event handlers
    inlineTagTooltip = $tooltip;
    inlineTagTooltip.on('click', (e) => e.stopPropagation());

    inlineTagTooltip.find('.tooltip-search-input').on('keyup', function() {
        const searchTerm = $(this).val().toLowerCase();
        inlineTagTooltip.find('.tooltip-tag-item').each(function() {
            const tagName = $(this).find('.tag-name').text().toLowerCase();
            $(this).toggle(tagName.includes(searchTerm));
        });
    });

    // --- Definitive FIX for the tooltip's delete button ---
    inlineTagTooltip.on('click', '.tooltip-delete-btn', function() {
        if (currentlyClickedTag) {
            const tagElement = currentlyClickedTag;
            if (tagElement.parentNode) {
                const fragment = document.createDocumentFragment();
                while (tagElement.firstChild) {
                    fragment.appendChild(tagElement.firstChild);
                }
                const labelToRemove = fragment.querySelector('.tag-label-on-span');
                if (labelToRemove) {
                    fragment.removeChild(labelToRemove);
                }
                tagElement.parentNode.replaceChild(fragment, tagElement);
                const container = document.getElementById('transcription-display-area');
                if (container && currentRegionForTagging) {
                    currentRegionForTagging.data.annotatedHtml = container.innerHTML;
                }
                changed();
            }
        }
        hideInlineTagTooltip();
        window.getSelection().removeAllRanges();
    });

    // Click handler for the close button
    inlineTagTooltip.on('click', '.tooltip-close-btn', function() {
        hideInlineTagTooltip();
    });
}

/** Hides the tooltip and removes temporary global event listeners. */
function hideInlineTagTooltip() {
    if (inlineTagTooltip) inlineTagTooltip.hide();
    $(document).off('mousedown.inline-tagger keydown.inline-tagger');
    currentSelectionRange = null;
    currentlyClickedTag = null; // <-- ADD THIS LINE FOR CLEANUP
}

function showInlineTagTooltip(e) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;
    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    
    // --- Positioning logic (remains the same) ---
    let top = window.scrollY + rect.top - inlineTagTooltip.outerHeight() - 10;
    let left = window.scrollX + rect.left + (rect.width / 2) - (inlineTagTooltip.outerWidth() / 2);
    if (top < window.scrollY) top = window.scrollY + rect.bottom + 10;
    if (left < window.scrollX) left = window.scrollX + 5;
    if (left + inlineTagTooltip.outerWidth() > window.innerWidth) left = window.innerWidth - inlineTagTooltip.outerWidth() - 5;

    const tagListContainer = inlineTagTooltip.find('.tooltip-tag-list');
    tagListContainer.empty(); // Clear any old tags from a previous opening.

    // --- THIS IS THE NEW DYNAMIC LOGIC ---
    
    // Use the taxonomy data loaded from the descriptor. Fallback to an empty array.
    const tagHierarchy = descriptor.labelForTagging || [];


// This entire `createTagItem` function goes INSIDE the `showInlineTagTooltip` function.

/**
 * Recursively creates a tag item UI and handles all sub-menu logic with a
 * professional-grade hover and click experience. This version fixes all selection issues.
 * @param {object} tagNode - A node from your tagHierarchy JSON.
 * @returns {jQuery} The created jQuery element for the tag item.
 */
function createTagItem(tagNode) {
    const hasSubTags = tagNode.children && tagNode.children.length > 0;
    let hideSubMenuTimer = null;

    const tagItem = $(`
        <div class="tooltip-tag-item" data-tag-id="${tagNode.id}">
            <span class="tag-color-indicator" style="background-color: ${tagNode.color};"></span>
            <span class="tag-name">${tagNode.name}</span>
            ${hasSubTags ? '<span class="submenu-indicator"><i class="fa fa-chevron-right"></i></span>' : ''}
        </div>
    `);

    if (hasSubTags) {
        const createAndShowSubMenu = () => {
            // Remove any other sub-menus at this level to prevent clutter
            tagItem.siblings().find('.sub-tag-tooltip').remove();

            const subMenu = $('<div class="sub-tag-tooltip"></div>');
            tagNode.children.forEach(childNode => {
                subMenu.append(createTagItem(childNode));
            });
            
            subMenu.on('mouseenter', () => clearTimeout(hideSubMenuTimer));
            subMenu.on('mouseleave', () => subMenu.remove());

            tagItem.append(subMenu);

            // =========================================================================
            // --- START: CONTEXT-AWARE POSITIONING LOGIC ---
            // =========================================================================

            // 1. Determine the parent menu's direction by checking its CSS.
            const parentSubMenu = tagItem.closest('.sub-tag-tooltip');
            const isParentFlippedLeft = parentSubMenu.length > 0 && parentSubMenu.css('right') !== 'auto';

            // 2. Set the INITIAL direction based on the parent. If the parent went left, we follow.
            if (isParentFlippedLeft) {
                subMenu.css({ right: 'calc(100% + 5px)', left: 'auto' });
            } else {
                // The default behavior is to always open to the right.
                subMenu.css({ left: 'calc(100% + 5px)', right: 'auto' });
            }

            // 3. Now, show the menu so we can get its actual dimensions and position.
            subMenu.show();

            // 4. Perform a final CORRECTION pass to handle any remaining edge cases.
            const subMenuRect = subMenu[0].getBoundingClientRect();
            const parentItemRect = tagItem[0].getBoundingClientRect();
            const viewportWidth = window.innerWidth;

            const overflowsRight = subMenuRect.right > viewportWidth;
            const overflowsLeft = subMenuRect.left < 0;

            if (isParentFlippedLeft) {
                // It was placed on the LEFT, but it still overflows the left edge.
                // As a last resort, we try to flip it back to the right, but only if there's room.
                const hasSpaceOnRight = (viewportWidth - parentItemRect.right) >= subMenuRect.width;
                if (overflowsLeft && hasSpaceOnRight) {
                    subMenu.css({ left: 'calc(100% + 5px)', right: 'auto' });
                }
            } else {
                // It was placed on the RIGHT, but it overflows the right edge.
                // We flip it to the left, but only if there's room.
                const hasSpaceOnLeft = parentItemRect.left >= subMenuRect.width;
                if (overflowsRight && hasSpaceOnLeft) {
                    subMenu.css({ right: 'calc(100% + 5px)', left: 'auto' });
                }
            }
            // =========================================================================
            // --- END OF FIX ---
            // =========================================================================
        };

        // --- Event handlers remain the same ---
        tagItem.on('click', function(e) {
            e.stopPropagation();
            const existingSubMenu = $(this).find('.sub-tag-tooltip');
            if (existingSubMenu.length) {
                existingSubMenu.remove();
            } else {
                createAndShowSubMenu();
            }
        });

        tagItem.on('mouseenter', function() {
            clearTimeout(hideSubMenuTimer);
            if ($(this).find('.sub-tag-tooltip').length === 0) {
                createAndShowSubMenu();
            }
        });

        tagItem.on('mouseleave', function() {
            hideSubMenuTimer = setTimeout(() => {
                $(this).find('.sub-tag-tooltip').remove();
            }, 300);
        });

    } else {
        // --- Leaf node click handler (no change here) ---
        tagItem.on('click', function(event) {
            event.stopPropagation(); 
            applyTagToSelection(tagNode);
        });
    }

    return tagItem;
}

    // Start the recursive process by iterating over the top-level tags.
    if (tagHierarchy.length > 0) {
        tagHierarchy.forEach(tagNode => {
            const tagItem = createTagItem(tagNode);
            tagListContainer.append(tagItem);
        });
    } else {
        tagListContainer.html('<div style="padding: 10px; color: #888;">No taxonomy loaded.</div>');
    }

    // --- END OF DYNAMIC LOGIC ---

    inlineTagTooltip.css({ top: top + 'px', left: left + 'px' }).show();

    // Setup listeners to close the main tooltip (remains the same).
    setTimeout(() => {
        $(document).on('mousedown.inline-tagger', (event) => {
            if (!$(event.target).closest('#inline-tag-tooltip').length) {
                hideInlineTagTooltip();
            }
        });
        $(document).on('keydown.inline-tagger', (event) => {
            if (event.key === 'Escape') {
                hideInlineTagTooltip();
            }
        });
    }, 100);
}

function handleTextSelection(e) {
    // A small delay (50ms) allows the browser to clear the selection 
    // after a click before this logic runs.
    setTimeout(() => {
        currentlyClickedTag = null;
        currentTaggingSourceId = null;

        // Identify the active area
        const activeArea = $(e.target).closest('#transcription-display-area, #transliteration-display-area');
        if (activeArea.length === 0) {
            hideInlineTagTooltip();
            return;
        }
        currentTaggingSourceId = activeArea.attr('id');

        const selection = window.getSelection();
        const selectedText = selection.toString().trim();

        // 1. If user clicks on an existing tag, show the tooltip for editing/deleting
        const clickedTag = $(e.target).closest('.annotation-tag');
        if (clickedTag.length > 0) {
            currentlyClickedTag = clickedTag[0];
            const range = document.createRange();
            range.selectNode(currentlyClickedTag);
            currentSelectionRange = range;
            showInlineTagTooltip(e);
            selection.removeAllRanges();
            return;
        }

        // 2. Check if a NEW selection exists. 
        // If selection is collapsed (a simple click) or text is empty, hide the tooltip.
        if (!selection || selection.isCollapsed || selectedText.length === 0) {
            hideInlineTagTooltip();
            return;
        }

        // 3. Final check to ensure selection is within the valid container
        const container = activeArea[0];
        if (container.contains(selection.anchorNode) && container.contains(selection.focusNode)) {
            currentSelectionRange = selection.getRangeAt(0).cloneRange();
            showInlineTagTooltip(e);
        } else {
            hideInlineTagTooltip();
        }
    }, 50); // 50ms delay is the key fix
}

// In adl.js

/**
 * Wraps the selected text with a <span> and a label, storing the tag's unique ID.
 * This version prevents tag nesting/overlap and saves to the correct data property.
 * It also trims whitespace from the user's selection before applying the tag.
 * @param {object} tagNode The full tag object from the taxonomy (e.g., { id, name, color, output }).
 */
function applyTagToSelection(tagNode) {
    if (!currentSelectionRange || !currentRegionForTagging || !currentTaggingSourceId) return;

    // Work on a mutable copy of the selection range
    let range = currentSelectionRange.cloneRange();

    // 1. Trim whitespace from the user's selection first.
    // Move the start of the range forward as long as it points to a whitespace character
    while (range.startContainer.nodeType === Node.TEXT_NODE && range.startOffset < range.startContainer.length && /^\s$/.test(range.toString()[0])) {
        range.setStart(range.startContainer, range.startOffset + 1);
    }

    // Move the end of the range backward as long as the last character is whitespace
    while (range.endContainer.nodeType === Node.TEXT_NODE && range.endOffset > 0 && /^\s$/.test(range.toString()[range.toString().length - 1])) {
        range.setEnd(range.endContainer, range.endOffset - 1);
    }

    // If trimming resulted in an empty selection, do nothing.
    if (range.collapsed) {
        hideInlineTagTooltip();
        window.getSelection().removeAllRanges();
        return;
    }

    // ===== START OF THE FIX =====
    // 2. Intelligently expand the range to fully contain any partially selected tags.
    // This is the key to preventing leftover empty tags.
    const startNode = range.startContainer;
    const endNode = range.endContainer;

    // Find the closest ancestor tag at the start and end of the selection.
    const startAncestorTag = (startNode.nodeType === Node.ELEMENT_NODE ? startNode : startNode.parentElement).closest('.annotation-tag');
    const endAncestorTag = (endNode.nodeType === Node.ELEMENT_NODE ? endNode : endNode.parentElement).closest('.annotation-tag');

    // If an ancestor tag was found, expand the range to include it completely.
    if (startAncestorTag) {
        range.setStartBefore(startAncestorTag);
    }
    if (endAncestorTag) {
        range.setEndAfter(endAncestorTag);
    }
    // ===== END OF THE FIX =====


    // 3. Create the new tag element that will replace the selection.
    const newTagSpan = document.createElement('span');
    newTagSpan.className = 'annotation-tag';
    newTagSpan.setAttribute('data-tag-id', tagNode.id);
    newTagSpan.style.borderTopColor = tagNode.color;
    newTagSpan.style.backgroundColor = tagNode.color + '33'; // '33' for ~20% opacity

    const labelDiv = document.createElement('div');
    labelDiv.className = 'tag-label-on-span';
    labelDiv.style.backgroundColor = tagNode.color;
    labelDiv.innerHTML = `<span class="tag-label-text">${tagNode.name}</span><span class="tag-label-delete" title="Remove tag">&times;</span>`;
    // Note: The actual content will be added after cleaning.

    try {
        // 4. Extract the content of our (now expanded) range.
        // This removes the old content from the DOM, including any complete old tags.
        const selectedContentFragment = range.extractContents();

        // 5. Clean the extracted content by "unwrapping" any old tags found inside.
        const tempDiv = document.createElement('div');
        tempDiv.appendChild(selectedContentFragment);
        tempDiv.querySelectorAll('.annotation-tag').forEach(span => {
            const fragment = document.createDocumentFragment();
            // Move the tag's children (like its text) to a temporary fragment.
            while (span.firstChild) {
                fragment.appendChild(span.firstChild);
            }
            // Find and discard the old label from the fragment.
            const labelToRemove = fragment.querySelector('.tag-label-on-span');
            if (labelToRemove) {
                fragment.removeChild(labelToRemove);
            }
            // Replace the old span with its cleaned-up content.
            if (span.parentNode) {
                span.parentNode.replaceChild(fragment, span);
            }
        });

        // 6. Append the now-clean content and the new label into our new tag span.
        newTagSpan.appendChild(labelDiv);
        while (tempDiv.firstChild) {
            newTagSpan.appendChild(tempDiv.firstChild);
        }

        // 7. Insert the new, consolidated tag back into the document.
        range.insertNode(newTagSpan);

        // 8. Save the updated HTML to the correct data property.
        const container = document.getElementById(currentTaggingSourceId);
        if (container) {
            if (currentTaggingSourceId === 'transcription-display-area') {
                currentRegionForTagging.data.annotatedHtml = container.innerHTML;
            } else if (currentTaggingSourceId === 'transliteration-display-area') {
                currentRegionForTagging.data.annotatedHtmlTransliteration = container.innerHTML;
            }
        }
        changed();

    } catch (err) {
        console.error("Error applying tag:", err);
        // In case of error, try to restore the original state to avoid data loss
        const container = document.getElementById(currentTaggingSourceId);
        if (container && currentRegionForTagging) {
             if (currentTaggingSourceId === 'transcription-display-area') {
                container.innerHTML = currentRegionForTagging.data.annotatedHtml || currentRegionForTagging.data.transcription || '';
            } else {
                container.innerHTML = currentRegionForTagging.data.annotatedHtmlTransliteration || currentRegionForTagging.data.transcriptionLatin || '';
            }
        }

    } finally {
        // 9. Clean up the UI.
        hideInlineTagTooltip();
        window.getSelection().removeAllRanges();
    }
}

function renderAnnotatedTranscription(region) {
    if (region.data && region.data.annotatedHtml) {
        return region.data.annotatedHtml;
    }
    return (region.data && region.data.transcription) || 'No transcription available.';
}

/** Renders transliteration text, rebuilding any saved inline annotations. */
function renderAnnotatedTransliteration(region) {
    if (region.data && region.data.annotatedHtmlTransliteration) {
        return region.data.annotatedHtmlTransliteration;
    }
    return (region.data && region.data.transcriptionLatin) || '';
}

/** Closes the tag drawer. */
function closeTagDrawer() {
    $('#tag-drawer-overlay').removeClass('active');
    $('#tag-drawer').removeClass('active').off('click').find('.tag-drawer-close-btn').off('click');
}

function openTagDrawer(region, index) {
    currentRegionForTagging = region;
    if ($('#tag-drawer-overlay').length === 0) {
        $('body').append('<div id="tag-drawer-overlay" class="tag-drawer-overlay"></div>');
        $('body').append('<div id="tag-drawer" class="tag-drawer"></div>');
    }
    const overlay = $('#tag-drawer-overlay');
    const drawer = $('#tag-drawer');

    const headerHtml = `
        <div class="tag-drawer-header">
            <h5><i class="fa fa-tag"></i>  Tagging System</h5>
            <button class="tag-drawer-close-btn"><i class="fa fa-times"></i></button>
        </div>`;

    const finalTranscriptionHtml = region.data.annotatedHtml || region.data.transcription || '';
    const finalTransliterationHtml = region.data.annotatedHtmlTransliteration || region.data.transcriptionLatin || '';

    const contentHtml = `
        <div class="tag-drawer-content">
            <div class="tag-drawer-section">
                <div class="tag-drawer-section-title">TRANSCRIPTION DATA</div>
                <div id="transcription-display-area" class="tag-drawer-section-value" contenteditable="true">${finalTranscriptionHtml}</div>
            </div>
            
            <div id="transliteration-drawer-section" class="tag-drawer-section" style="display:none;">
                <div class="tag-drawer-section-title">TRANSLITERATION DATA</div>
                <div id="transliteration-display-area" class="tag-drawer-section-value" contenteditable="true">${finalTransliterationHtml}</div>
            </div>
        </div>`;
        
    drawer.html(headerHtml + contentHtml);

    if ($('#transliterate-toggle').is(':checked')) {
        $('#transliteration-drawer-section').show();
    }

    overlay.addClass('active');
    drawer.addClass('active');

    const transcriptionArea = drawer.find('#transcription-display-area');
    const transliterationArea = drawer.find('#transliteration-display-area');

    // Attach mouseup event to both editable areas to handle text selection
    drawer.find('.tag-drawer-section-value').on('mouseup', handleTextSelection);
    drawer.find('.tag-drawer-section-value').on('dragstart drop', (e) => {
    e.preventDefault();
    return false;
});
    // ===== FIX START: Prevent manual text entry in the drawer =====
    // This new keydown handler blocks typing, deleting, and pasting,
    // but allows keys needed for text selection and navigation.
    drawer.find('.tag-drawer-section-value').on('keydown', (e) => {
        // Allow navigation and selection keys (Arrows, Home, End, Shift, Ctrl, Alt, Meta)
        if ([
            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Home', 'End', 'PageUp', 'PageDown',
            'Shift', 'Control', 'Alt', 'Meta'
        ].includes(e.key)) {
            return; // Do not block these keys
        }

        // Allow the "Copy" command (Ctrl+C or Cmd+C)
        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'c') {
            return; // Do not block copy
        }

        // Block all other keys (letters, numbers, space, backspace, delete, enter, etc.)
        e.preventDefault();
    });
    // ===== FIX END =====

    // The blur handler is no longer needed since the content cannot be edited by typing.
    // It is safe to remove it, but leaving it will cause no harm.
    function handleContentEditBlur(e) {
        const target = $(e.currentTarget);
        const sourceId = target.attr('id');
        const newHtml = target.html();
        const newText = target.text();

        if (currentRegionForTagging) {
            let hasChanged = false;
            if (sourceId === 'transcription-display-area') {
                if (currentRegionForTagging.data.annotatedHtml !== newHtml) {
                    currentRegionForTagging.data.annotatedHtml = newHtml;
                    currentRegionForTagging.data.transcription = newText;
                    hasChanged = true;
                }
            } else if (sourceId === 'transliteration-display-area') {
                if (currentRegionForTagging.data.annotatedHtmlTransliteration !== newHtml) {
                    currentRegionForTagging.data.annotatedHtmlTransliteration = newHtml;
                    currentRegionForTagging.data.transcriptionLatin = newText;
                    hasChanged = true;
                }
            }

            if (hasChanged) {
                changed();
                if (window.waveReport) {
                    window.waveReport();
                }
            }
        }
    }
    
    transcriptionArea.on('blur', handleContentEditBlur);
    transliterationArea.on('blur', handleContentEditBlur);

    // This is the NEW, corrected code. Paste it in the `openTagDrawer` function.
drawer.on('click', '.tag-label-delete', function(e) {
    e.stopPropagation();
    const annotationSpan = $(this).closest('.annotation-tag')[0];
    const container = $(this).closest('.tag-drawer-section-value')[0];

    if (annotationSpan && annotationSpan.parentNode && container) {
        // 1. Unwrap the clicked span to remove it, leaving its text content.
        const fragment = document.createDocumentFragment();
        while (annotationSpan.firstChild) {
            fragment.appendChild(annotationSpan.firstChild);
        }
        const labelToRemove = fragment.querySelector('.tag-label-on-span');
        if (labelToRemove) {
            fragment.removeChild(labelToRemove);
        }
        annotationSpan.parentNode.replaceChild(fragment, annotationSpan);

        // --- START OF THE FIX ---

        // 2. Get the updated HTML from the editor.
        const updatedHtml = container.innerHTML;

        // 3. To get the clean plain text, create a temporary in-memory element.
        const $tempDiv = $('<div>').html(updatedHtml);

        // 4. Remove all remaining tag label elements from this temporary copy.
        $tempDiv.find('.tag-label-on-span').remove();

        // 5. Get the pure text from the cleaned-up temporary element.
        const cleanText = $tempDiv.text();

        // 6. Save the updated HTML and the correctly calculated plain text.
        if (container.id === 'transcription-display-area') {
            currentRegionForTagging.data.annotatedHtml = updatedHtml;
            currentRegionForTagging.data.transcription = cleanText;
        } else if (container.id === 'transliteration-display-area') {
            currentRegionForTagging.data.annotatedHtmlTransliteration = updatedHtml;
            currentRegionForTagging.data.transcriptionLatin = cleanText;
        }
        
        // --- END OF THE FIX ---

        // 7. Mark the task as changed and refresh the table UI.
        changed();
        waveReport();
    }
});

    drawer.find('.tag-drawer-close-btn').on('click', closeTagDrawer);
    overlay.on('click', closeTagDrawer);
    drawer.on('click', (e) => e.stopPropagation());
}
/**
 * Calculates the browser's scrollbar width dynamically.
 * @returns {number} The width of the scrollbar in pixels.
 */
function getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.msOverflowStyle = 'scrollbar'; // For IE/Edge
    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
}

// REPLACE your entire waveReport function with this version

function waveReport() {
    var reportObj = window.reportObj;
    if (!reportObj) { console.warn("Report Object missing"); return; }

    var $oldTbody = reportObj.find('.reporttable tbody');
    var previousScrollTop = 0;
    if ($oldTbody.length) previousScrollTop = $oldTbody.scrollTop() || 0;
    var previouslySelected = currentlyActiveRegionId;

    reportObj.show().css('display', 'block');
    reportObj.html('');

    var ranges = [];
    if (window.wavesurfer && window.wavesurfer.regions) {
        Object.keys(window.wavesurfer.regions.list).forEach(function (id) {
            ranges.push(window.wavesurfer.regions.list[id]);
        });
    }

    ranges.sort(function (a, b) { return a.start - b.start; });

    if (ranges.length === 0) {
        return reportObj.html('<div class="p-3 text-muted text-center">(No segments created)</div>');
    }

    var tab = $('<TABLE>').addClass('reporttable table table-sm').css({
        'width': '100%', 'background': '#fff', 'color': '#000'
    });

    var thead = $('<THEAD>').append(`
        <tr>
            <th>ID</th>
            <th>Speaker</th>
            <th>Start</th>
            <th>End</th>
            <th>Primary Type</th>
            <th>Loudness</th>
            <th>Language</th>
            <th title="Segment Language">Seg.Lang</th>
            <th>TranscriptionData</th>
            <th class="latin-column" style="display:none;">Transliteration</th>
            <th style="padding:8px 2px !important; text-align:center;">Action</th>
            <th style="padding:8px 2px !important; text-align:center;" title="Toggle all segments visibility">
                <i id="toggle-all-visibility-btn" class="fa fa-eye" style="cursor:pointer;"></i>
            </th>
        </tr>
    `);
    tab.append(thead);
    var tbody = $('<TBODY>');

    let allVisible = true;
    // FIX: Check the live state of the toggle directly from the DOM
    const isTaggedView = $('#tagged-output-toggle').is(':checked');

    ranges.forEach(function (r, index) {
        var tr_row = $('<TR>').prop('id', 'wavereport' + r.id).css('cursor', 'pointer');
        tr_row.append($('<TD>').text(index + 1).css('vertical-align', 'middle'));

        var speakerTd = $('<TD>').css('vertical-align', 'middle');
        var speakerSelect = $('<select class="form-control form-control-sm speaker-select-cell">');
        var activeMode = window.currentMode || descriptor.currentMode;

        if (activeMode && activeMode.options) {
            activeMode.options.forEach((opt) => {
                var option = $('<option>').val(opt).text(opt);
                if (r.data.tag && r.data.tag.trim() === opt.trim()) {
                    option.prop('selected', true);
                }
                speakerSelect.append(option);
            });
            speakerSelect.on('mousedown', function(e) {
    if (window.descriptor.blockEdit) {
        e.preventDefault();
        showLockAlert();
    }
});
            speakerSelect.on('change', function () {
                if (window.descriptor.blockEdit) return;
                var newTag = $(this).val();
                r.data.tag = newTag;
                var tagIndex = activeMode.options.indexOf(newTag);
                var newColor = activeMode.colors[tagIndex % activeMode.colors.length];
                var finalColor = newColor + waveTransparency;
                r.data.originalColor = finalColor;
                r.update({ color: finalColor });
                waveRegionText(r, newTag);
                waveReport();
                changed();
            }).on('click dblclick', function(e) { e.stopPropagation(); });
            
            var speakerWrapper = $('<div>').addClass('speaker-select-wrapper');
            speakerWrapper.append(speakerSelect);
            speakerTd.append(speakerWrapper);
            tr_row.append(speakerTd);
        } else {
            tr_row.append($('<TD>').text((r.data && r.data.tag) || 'Unknown').css('vertical-align', 'middle'));
        }

        tr_row.append($('<TD>').text(formatTimeWithMilliseconds(r.start)).css('vertical-align', 'middle'));
        tr_row.append($('<TD>').text(formatTimeWithMilliseconds(r.end)).css('vertical-align', 'middle'));

        var toneTd = $('<TD>');
        var toneSelect = $('<select class="form-control form-control-sm" style="font-size:12px;">');
        var primaryOptions = (activeMode && activeMode['Primary Type']) || [];
        primaryOptions.forEach(opt => {
            var option = $('<option>').val(opt).text(opt);
            if (r.data.tone && r.data.tone.trim() === opt.trim()) option.attr('selected', true);
            toneSelect.append(option);
        });
        // For Primary Type Select
        toneSelect.on('mousedown', function(e) {
            if (window.descriptor.blockEdit) {
                e.preventDefault();
                showLockAlert();
            }
        });
        toneSelect.on('change', function () {
            r.data.tone = $(this).val();
            waveReport(); 
            changed();
        }).on('click dblclick', function(e) { e.stopPropagation(); });
        toneTd.append(toneSelect);
        tr_row.append(toneTd);

        var loudTd = $('<TD>');
        var loudSelect = $('<select class="form-control form-control-sm" style="font-size:12px;">');
        var loudOptions = (activeMode && activeMode['Loudness Level']) || ['Normal', 'Quiet', 'Loud'];
        loudOptions.forEach(opt => {
            var option = $('<option>').val(opt).text(opt);
            if (r.data.loudness && r.data.loudness.trim() === opt.trim()) option.attr('selected', true);
            loudSelect.append(option);
        });
        loudSelect.on('mousedown', function(e) {
            if (window.descriptor.blockEdit) {
                e.preventDefault();
                showLockAlert();
            }
        });
        loudSelect.on('change', function () { r.data.loudness = $(this).val(); changed(); }).on('click dblclick', function(e) { e.stopPropagation(); });
        loudTd.append(loudSelect);
        tr_row.append(loudTd);
        
        var langTd = $('<TD>').addClass('text-center action-cell');
        var langInput = $('<input type="text" class="form-control form-control-sm">').val(r.data.language || '').on('change', function() { r.data.language = $(this).val(); changed(); }).on('click dblclick keydown', function(e) { e.stopPropagation(); });
        langInput.on('mousedown', function(e) {
    if (window.descriptor.blockEdit) {
        e.preventDefault();
        showLockAlert();
    }
});
        langTd.append(langInput);
        tr_row.append(langTd);

        var segLangTd = $('<TD>').addClass('text-center action-cell');
        var segLangInput = $('<input type="text" class="form-control form-control-sm">').val(r.data.segmentLanguage || '').on('change', function() { r.data.segmentLanguage = $(this).val(); changed(); }).on('click dblclick keydown', function(e) { e.stopPropagation(); });
                segLangInput.on('mousedown', function(e) {
            if (window.descriptor.blockEdit) {
                e.preventDefault();
                showLockAlert();
            }
        });
        segLangTd.append(segLangInput);
        tr_row.append(segLangTd);

        var currentTone = r.data.tone || (primaryOptions && primaryOptions[0]) || '';
        var transTd = $('<TD>').addClass('transcription-cell');
        var transInput = $('<textarea class="form-control form-control-sm transcription-input" rows="2" placeholder="Type Transcription here..."></textarea>');
        var transcriptionInlineOptions = (activeMode && activeMode['Transcription Inline']) || [];
        var allowTranscription = transcriptionInlineOptions.map(o => o.toLowerCase()).includes(currentTone.toLowerCase());
        
        function autoExpand(textarea) {
            if (!textarea) return;
            textarea.style.height = 'auto';
            textarea.style.height = Math.max(60, textarea.scrollHeight) + 'px';
        }

        var transLatinTd = $('<TD>').addClass('transcription-cell latin-column').hide();
        var transLatinInput = $('<textarea class="form-control form-control-sm transcription-latin-input" rows="2" placeholder="Type transliteration here..."></textarea>');

        // --- NEW LOGIC FOR TAGGED OUTPUT VIEW ---
        if (isTaggedView) {
    // If tagged view is ON, show the generated output, disable editing, and apply preview styles
    const taggedTranscription = r.data.annotatedHtml ? generateTaggedOutput(r.data.annotatedHtml, descriptor.labelForTagging || []) : r.data.transcription || "";
    transInput.val(taggedTranscription).prop('disabled', true).addClass('tagged-output-preview');

    const taggedTransliteration = r.data.annotatedHtmlTransliteration ? generateTaggedOutput(r.data.annotatedHtmlTransliteration, descriptor.labelForTagging || []) : r.data.transcriptionLatin || "";
    transLatinInput.val(taggedTransliteration).prop('disabled', true).addClass('tagged-output-preview');
} else {
            // If tagged view is OFF, use the existing logic for normal view
            transInput.val(r.data.transcription || '');
            transInput.on('mousedown', function(e) {
    if (window.descriptor.blockEdit) {
        e.preventDefault();
        showLockAlert();
    }
});
            transInput.on('input', function () {
                $(this).closest('tr').removeClass('table-row-invalid');
                autoExpand(this);
                r.data.transcription = $(this).val();
                r.data.annotatedHtml = "";
                changed();
            }).on('change', function () {
                r.data.transcription = $(this).val();
                r.data.annotatedHtml = "";
                changed();
            }).on('click dblclick keydown', e => e.stopPropagation());

            transLatinInput.val(r.data.transcriptionLatin || '');
            transLatinInput.on('mousedown', function(e) {
    if (window.descriptor.blockEdit) {
        e.preventDefault();
        showLockAlert();
    }
});
            transLatinInput.on('input', function() {
                $(this).closest('tr').removeClass('table-row-invalid');
                autoExpand(this);
                r.data.transcriptionLatin = $(this).val();
                r.data.annotatedHtmlTransliteration = "";
                changed();
            }).on('change', function() {
                r.data.transcriptionLatin = $(this).val();
                r.data.annotatedHtmlTransliteration = "";
                changed();
            }).on('click dblclick keydown', function(e) { e.stopPropagation(); });
        }
        // --- END OF NEW LOGIC ---

        setTimeout(() => autoExpand(transInput[0]), 0);
        setTimeout(() => autoExpand(transLatinInput[0]), 0);

        transTd.append(transInput);
        tr_row.append(transTd);
        
        transLatinTd.append(transLatinInput);
        tr_row.append(transLatinTd);

        var actTd = $('<TD>').addClass('action-cell').css({
            'text-align': 'center',
            'padding': '6px 2px !important'
        });
        var actionContainer = $('<div>').addClass('action-edit-delete');
        var tagBtn = $('<button class="btn btn-sm btn-link text-info action-tag p-0" title="Tag Details"><i class="fa fa-tag"></i></button>');
        var editBtn = $('<button class="btn btn-sm btn-link text-primary action-edit p-0" title="Edit"><i class="fa fa-pencil"></i></button>');
        var delBtn = $('<button class="btn btn-sm btn-link text-danger action-delete p-0" title="Delete"><i class="fa fa-trash"></i></button>');

        tagBtn.on('click', function(e) {
            e.stopPropagation();
            if (window.descriptor.blockEdit) return showLockAlert();
            const isTransliterationEnabled = $('#transliterate-toggle').is(':checked');
            if ((r.data.transcription || '').trim() === '') {
                myAlert(
                    'Transcription Required',
                    'The transcription area is empty. Please fill it before using the tagging feature.',
                    '^Ok',
                    function() {
                        myAlertClose(function() {
                            currentlyEditingRow.index = r.id;
                            waveReport();
                            setTimeout(() => {
                                $('#wavereport' + r.id).find('.transcription-input').focus();
                            }, 50);
                        });
                    },
                    'Cancel',
                    function() {
                        myAlertClose();
                    }
                );
                return;
            }
            if (isTransliterationEnabled && (r.data.transcriptionLatin || '').trim() === '') {
                myAlert(
                    'Transliteration Required',
                    'Transliteration is enabled, but this field is empty. Please fill it before using the tagging feature.',
                    '^Ok',
                    function() {
                        myAlertClose(function() {
                            currentlyEditingRow.index = r.id;
                            waveReport();
                            setTimeout(() => {
                                $('#wavereport' + r.id).find('.transcription-latin-input').focus();
                            }, 50);
                        });
                    },
                    'Cancel',
                    function() {
                        myAlertClose();
                    }
                );
                return;
            }
            openTagDrawer(r, index);
        });

        var isEditingThisRow = (r.id === currentlyEditingRow.index);
        
        // --- MODIFIED LOGIC: Disable editing buttons if in tagged view ---
        if (isTaggedView) {
            transInput.prop('disabled', true);
            transLatinInput.prop('disabled', true);
            editBtn.hide();
            tagBtn.hide();
        } else if (isEditingThisRow && allowTranscription) {
            transInput.prop('disabled', false).removeClass('transcription-confirmed');
            transLatinInput.prop('disabled', false).removeClass('transcription-confirmed');
            editBtn.hide();
            tagBtn.hide();
            transInput.add(transLatinInput).on('blur', function() {
                setTimeout(() => {
                    const focusedElement = document.activeElement;
                    const $currentRow = $(this).closest('tr');
                    
                    if (!$currentRow.is($(focusedElement).closest('tr'))) {
                        currentlyEditingRow.index = null;
                        waveReport();
                    }
                }, 100); 
            });
        } else {
            transInput.prop('disabled', true).addClass('transcription-confirmed');
            transLatinInput.prop('disabled', true).addClass('transcription-confirmed');
            
            if (allowTranscription) {
                editBtn.show();
                tagBtn.show();
            } else {
                editBtn.hide();
                tagBtn.hide();
            }
        }
        
        if (!allowTranscription) {
            transInput.hide();
            transLatinInput.hide();
        }

        editBtn.on('click', function(e) {
            e.stopPropagation();
            if (window.descriptor.blockEdit) return showLockAlert();
            const isTransliterationEnabled = $('#transliterate-toggle').is(':checked');
            const hasTranscriptionTags = r.data.annotatedHtml && r.data.annotatedHtml.includes('annotation-tag');
            const hasTransliterationTags = (r.data.annotatedHtmlTransliteration && r.data.annotatedHtmlTransliteration.includes('annotation-tag')) && isTransliterationEnabled;
            if (hasTranscriptionTags || hasTransliterationTags) {
                myAlert(
                    'Confirm Tag Removal', 
                    'This segment contains tags. If you make any changes, all tags will be removed. Do you want to proceed?', 
                    '^Continue', 
                    function() {
                        myAlertClose(function() {
                            currentlyEditingRow.index = r.id;
                            waveReport(); 
                            setTimeout(() => {
                                $('#wavereport' + r.id).find('.transcription-input').focus();
                            }, 50);
                        });
                    }, 
                    'Cancel', 
                    function() {
                        myAlertClose();
                    }
                );
            } else {
                currentlyEditingRow.index = r.id;
                waveReport();
                setTimeout(() => {
                    $('#wavereport' + r.id).find('.transcription-input').focus();
                }, 50);
            }
        });

        delBtn.on('click', function(e) {
            e.stopPropagation();
            if (window.descriptor.blockEdit) return showLockAlert();
            myAlert('Confirm Deletion', 'Are you sure you want to delete this segment?', '*Delete', function() {
                const scrollContainer = $('.reporttable tbody');
                const scrollPosition = scrollContainer.scrollTop();
                r.remove();
                if (currentlyEditingRow.index === r.id) {
                    currentlyEditingRow.index = null;
                }
                window.waveReport();
                changed();
                $('.reporttable tbody').scrollTop(scrollPosition);
                myAlertClose();
            }, 'Cancel', function() {
                myAlertClose();
            });
        });
        
        actionContainer.append(tagBtn, editBtn, delBtn);
        actTd.append(actionContainer);
        tr_row.append(actTd);
        
        var eyeTd = $('<TD>').addClass('action-cell').css({
            'text-align': 'center',
            'padding': '6px 2px !important'
        });
        var eyeBtn = $('<button class="visibility-toggle" title="Toggle segment visibility in waveform"></button>');
        
        if (r.data.isVisible === undefined) {
            r.data.isVisible = true;
        }

        if (!r.data.isVisible) {
            allVisible = false;
        }

        function updateRowVisibility() {
            if (r.data.isVisible) {
                eyeBtn.html('<i class="fa fa-eye" style="color: #7367f0;"></i>');
                eyeBtn.attr('title', 'Click to hide segment in waveform');
                if (r.element) r.element.style.display = 'block';
            } else {
                eyeBtn.html('<i class="fa fa-eye-slash" style="color: #6c757d;"></i>');
                eyeBtn.attr('title', 'Click to show segment in waveform');
                if (r.element) r.element.style.display = 'none';
            }
        }
        
        updateRowVisibility();
        
        eyeBtn.on('click', function(e) {
            if (window.descriptor.blockEdit) return showLockAlert();
            e.stopPropagation();
    
    // 1. Toggle the data state
    r.data.isVisible = !r.data.isVisible;
    
    // 2. Update the icon and waveform IMMEDIATELY without re-rendering the whole table
    if (r.data.isVisible) {
        $(this).html('<i class="fa fa-eye" style="color: #7367f0;"></i>');
        $(this).attr('title', 'Click to hide segment in waveform');
        if (r.element) r.element.style.display = 'block';
    } else {
        $(this).html('<i class="fa fa-eye-slash" style="color: #6c757d;"></i>');
        $(this).attr('title', 'Click to show segment in waveform');
        if (r.element) r.element.style.display = 'none';
    }

    // 3. Manually update the "Toggle All" icon in the header to stay in sync
    const allRegions = Object.values(window.wavesurfer.regions.list);
    const anyHidden = allRegions.some(reg => reg.data.isVisible === false);
    const $toggleAllBtn = $('#toggle-all-visibility-btn');
    
    if (anyHidden) {
        $toggleAllBtn.removeClass('fa-eye').addClass('fa-eye-slash').css('color', '');
    } else {
        $toggleAllBtn.removeClass('fa-eye-slash').addClass('fa-eye').css('color', '');
    }

    // 4. Trigger auto-save but DO NOT call waveReport()
    changed(); 
});
        
        eyeTd.append(eyeBtn);
        tr_row.append(eyeTd);
        
        var clickTimer = null;
        tr_row.on('click', function () {
            clearTimeout(clickTimer);
            clickTimer = setTimeout(() => {
                userExplicitlySelectedRegion = true;
                clearTimeout(userSelectionTimeout);
                if (currentlyActiveRegionId !== r.id) {
                    if (currentlyActiveRegionId) $('#wavereport' + currentlyActiveRegionId).removeClass('table-active');
                    currentlyActiveRegionId = r.id;
                    updateAllRegionHighlights();
                }
                $(this).addClass('table-active');
                if (window.wavesurfer) {
                    if (window.wavesurfer.isPlaying()) window.wavesurfer.pause();
                    window.wavesurfer.seekTo((r.start + 0.01) / window.wavesurfer.getDuration());
                }
                userSelectionTimeout = setTimeout(() => { userExplicitlySelectedRegion = false; }, 250);
            }, 200);
        }).on('dblclick', function () {
            clearTimeout(clickTimer);
            userExplicitlySelectedRegion = true; 
            if (currentlyActiveRegionId !== r.id) {
                if (currentlyActiveRegionId) $('#wavereport' + currentlyActiveRegionId).removeClass('table-active');
                currentlyActiveRegionId = r.id;
                updateAllRegionHighlights();
            }
            $(this).addClass('table-active');
            if (window.wavesurfer) window.wavesurfer.play(r.start, r.end);
        });
        tbody.append(tr_row);
    });

    tab.append(tbody);
    reportObj.append(tab);
    
    const $toggleAllBtn = $('#toggle-all-visibility-btn');
    if (allVisible) {
        $toggleAllBtn.removeClass('fa-eye-slash').addClass('fa-eye').css('color', '#7367f0');
    } else {
        $toggleAllBtn.removeClass('fa-eye').addClass('fa-eye-slash').css('color', '#b9b9c3');
    }
    
    $toggleAllBtn.off('click').on('click', function() {
        if (window.descriptor.blockEdit) return showLockAlert();
        const makeVisible = $(this).hasClass('fa-eye-slash'); 
        
        if (window.wavesurfer && window.wavesurfer.regions) {
            Object.values(window.wavesurfer.regions.list).forEach(region => {
                region.data.isVisible = makeVisible;
            });
        }
        
        changed();
        waveReport();
    });
    

    const $newTbody = reportObj.find('.reporttable tbody');
    if ($newTbody.length) {
        if (userExplicitlySelectedRegion && previouslySelected) {
            const $targetRow = $newTbody.find('#wavereport' + previouslySelected);
            if ($targetRow.length) {
                const newScrollTop = Math.max(0, $newTbody.scrollTop() + $targetRow.position().top - ($newTbody.height() / 2) + ($targetRow.height() / 2));
                $newTbody.stop(true, true).animate({ scrollTop: newScrollTop }, 200);
            } else {
                $newTbody.scrollTop(previousScrollTop);
            }
        } else {
            $newTbody.scrollTop(previousScrollTop);
        }
    }
    
    const scrollbarWidth = getScrollbarWidth();
    reportObj.find('.reporttable thead').css('padding-right', scrollbarWidth + 'px');

    if ($('#transliterate-toggle').is(':checked')) {
        $('.latin-column').show();
    }
}
// Attach to window to ensure visibility
window.waveReport = waveReport;
window.setupTranscriptionImport = setupTranscriptionImport;
var waveTransparency = '77';

window.waveMode = function (m) {
    window.currentMode = totalModes[m];
    descriptor.currentMode = window.currentMode;

    $('.segmentation').remove();

    var segContainer = $('<div class="segmentation"></div>')
        .css({
            'display': 'flex', 'align-items': 'center', 'gap': '10px',
            'flex-wrap': 'wrap', 'margin-bottom': '10px', 'padding': '0 15px'
        });
    $('.waveinterface').prepend(segContainer);

    if (window.currentMode.type === 'segmentation' && Array.isArray(window.currentMode.options)) {
        window.currentMode.options.forEach((option, index) => {
            var color = window.currentMode.colors[index % window.currentMode.colors.length];
            // REPLACE with this NEW, corrected code
            var btn = $('<div>')
                .html(option)
                .prop('id', 'segbtn-' + index)
                .attr('data-segindex', index)
                .addClass('segmentation-opt unselectable')
                .css({
                    // The colored left border is now preserved
                    'border-left': '5px solid ' + color,
                    // Set the background to white
                    'background': '#ffffff',
                    'padding': '3px 12px',
                    'border-radius': '4px',
                    'cursor': 'pointer',
                    'font-size': '13px',
                    // Define other borders individually to match the target style
                    'border-top': '1px solid #a9c5e7',
                    'border-right': '1px solid #a9c5e7',
                    'border-bottom': '1px solid #a9c5e7'
                });
            segContainer.append(btn);
        });
        // Hide the full-size segmentation bar — we keep the compact clone next to zoom controls
        segContainer.hide();
    }

    // Logic for "+ Add segmentation" button
    if (window.currentMode.allowNew) {
        // (Existing code for the add button can remain here)
    }

    if (window.wavesurfer) {
        if (window.descriptor && window.descriptor.blockEdit) {
            window.wavesurfer.disableDragSelection();
        } else {
            // If the task is editable, enable drag selection.
            window.wavesurfer.enableDragSelection({
                color: 'rgba(0, 255, 0, 0.1)', // A neutral default color
                drag: true
            });
        }
    }

    // Update the cloned buttons in the zoom area
    try {
        const zoomContainer = $('.zoom-seg-buttons');
        if (zoomContainer.length) {
            zoomContainer.empty();
            const cloned = $('.segmentation .segmentation-opt').clone(true);
            cloned.each(function () { $(this).addClass('segmentation-opt-small'); });
            zoomContainer.append(cloned);
        }
    } catch (e) { /* fail silently if DOM not ready */ }
};

// 2. Selection Logic: Handles what happens when you click a button.
window.waveSegSelect = function (id) {
    // THIS IS THE KEY: Set the global variable to the index of the clicked button.
    window.currentSeg = id;

    var mode = window.currentMode || descriptor.currentMode;
    if (!mode || !mode.colors) return;
    var color = mode.colors[id % mode.colors.length];

    // REPLACE with this NEW, corrected line
    $('.segmentation-opt').css({ 'background': '#ffffff', 'color': '#333', 'font-weight': 'normal' });
    // Use data attribute to select ALL matching buttons (fixes issue with cloned buttons)
    $('[data-segindex="' + id + '"]').css({ 'background': color + '33', 'font-weight': 'bold', 'color': '#000' });

    // Set the drag color for the NEXT region you draw.
    if (window.wavesurfer) {
        window.wavesurfer.enableDragSelection({
            color: color + waveTransparency,
            drag: true
        });

        // If a region is ALREADY selected, change its tag to this one.
        if (window.wavesurfer.selectedRegion) {
            var region = window.wavesurfer.regions.list[window.wavesurfer.selectedRegion];
            if (region) {
                region.data.tag = mode.options[id];
                region.data.track = mode.name;
                region.data.mode = mode.id;
                region.update({ color: color + waveTransparency });
                if (window.waveReport) window.waveReport();
                changed();
            }
        }
    }
}


function waveModeReload() {
    var id = window.currentMode ? window.currentMode.id : 0;
    window.currentMode = null;
    window.waveMode(id);
}

function waveSegmentationEdit(tag) {
    if (!tag) tag = '';

    // Pause video/audio to focus on editing
    if (typeof video !== 'undefined' && video) video.pause();
    if (window.wavesurfer) window.wavesurfer.pause();

    if (!window.currentMode) return;

    var id = window.currentMode.options.indexOf(tag);

    var modalTitle = tag ? 'Edit Segmentation Tag' : 'Add New Segmentation Tag';

    // Setup Modal Buttons
    var params = [modalTitle, '', '^Set Tag', saveTag];
    if (id > -1) {
        params = params.concat(['*Delete Tag', remove]);
    }
    params = params.concat(['Cancel', function () { }]);

    // Show Modal
    myAlert.apply(this, params);

    // Inject Input Field
    var desc = $('<div class="question-field field"><div class="err"></div>').append($('<TEXTAREA id="tag-text" class="inote-text mt-2"></div>').prop('placeholder', 'Enter New Tag Name').val(tag));
    $('.modal-body').html('').append(desc);

    setTimeout(function () {
        $('#tag-text').select().on('keydown', function (ev) {
            if (ev.keyCode == 13) saveTag();
        });
    }, 500);

    // Delete Tag Logic
    function remove(ev) {
        if (ev && typeof cancelEvent === 'function') cancelEvent(ev);
        var tagToDelete = tag;

        // Remove from options list
        if (window.currentMode.options) {
            const idx = window.currentMode.options.indexOf(tagToDelete);
            if (idx > -1) window.currentMode.options.splice(idx, 1);
        }

        // Remove associated regions from WaveSurfer
        if (window.wavesurfer) {
            Object.values(window.wavesurfer.regions.list).forEach(r => {
                if (r.data.tag === tagToDelete) {
                    r.remove();
                }
            });
        }

        myAlertClose();
        waveModeReload();
        changed();
        if (typeof window.waveReport === 'function') window.waveReport();
    }

    // Save Tag Logic
    function saveTag(ev) {
        var newTag = $('#tag-text').val().trim();
        var originalTag = tag;

        if (!newTag) {
            $('.modal-body').find('.err').html('Enter the tag name');
            if (ev && typeof cancelEvent === 'function') cancelEvent(ev);
            return true;
        }

        if (newTag === originalTag) {
            myAlertClose();
            return;
        }

        // Check for duplicates
        let foundConflict = window.currentMode.options.find(opt => opt.toLowerCase() === newTag.toLowerCase());
        if (foundConflict && foundConflict !== originalTag) {
            alert(`Tag '${newTag}' already exists.`);
            return;
        }

        if (originalTag) {
            // Update existing tag
            const tagIndex = window.currentMode.options.indexOf(originalTag);
            if (tagIndex > -1) {
                window.currentMode.options[tagIndex] = newTag;
            }
            // Update all regions using this tag
            if (window.wavesurfer) {
                Object.values(window.wavesurfer.regions.list).forEach(r => {
                    if (r.data.tag === originalTag) {
                        r.data.tag = newTag;
                    }
                });
            }
        } else {
            // Add new tag
            window.currentMode.options.push(newTag);
        }

        if (window.wavesurfer) {
            window.wavesurfer.selectedRegion = null;
        }
        window.currentSeg = null;

        myAlertClose();
        waveModeReload();
        changed();
        if (typeof window.waveReport === 'function') window.waveReport();
    }
}
// ADL
// ADL
// ===== START: REPLACE THE ENTIRE waveLoadData FUNCTION =====
function waveLoadData() {
    if (!window.wavesurfer) return;
    
    isLoadingData = true; 
    
    window.wavesurfer.clearRegions();

    if (!descriptor.streams) {
        // If there are no streams, default the toggle state to false.
        descriptor.isTransliterationEnabled = false;
        isLoadingData = false; 
        return;
    }
    
    // --- DEFINITIVE FIX: Read state from the correct nested location ---
    // This sets the global state for the UI restoration logic that runs later.
    descriptor.isTransliterationEnabled = descriptor.streams.isTransliterationEnabled === true;

    var activeMode = window.currentMode || descriptor.currentMode || (totalModes[0]);
    if (!activeMode) {
        isLoadingData = false; 
        return;
    }

    var streamName = activeMode.name;
    
    if (descriptor.streams[streamName] && Array.isArray(descriptor.streams[streamName])) {
        descriptor.streams[streamName].forEach(item => {
            let start = timecodeToSeconds(item.start_time);
            let end = timecodeToSeconds(item.end_time);

            let tagIdx = activeMode.options.indexOf(item.tag);
            if (tagIdx === -1) tagIdx = 0;
            let color = activeMode.colors[tagIdx % activeMode.colors.length];
            let finalColor = color + waveTransparency;

            const newRegion = window.wavesurfer.addRegion({
                start: start,
                end: end,
                color: finalColor,
                drag: false,
                data: {
                    originalColor: finalColor,
                    tag: item.tag || activeMode.options[0],
                    tone: item.primaryType || "",
                    loudness: item.loudnessLevel || "Normal",
                    language: item.language || "",
                    segmentLanguage: item.segmentLanguage || "",
                    notes: item.notes || "",
                    transcription: item.transcription || "",
                    transcriptionConfirmed: item.transcriptionConfirmed || false,
                    transcriptionLatin: item.transcriptionLatin || "",
                    annotatedHtml: item.annotatedHtml || "", 
                    annotatedHtmlTransliteration: item.annotatedHtmlTransliteration || "",
                    track: streamName,
                    mode: activeMode.id
                }
            });
            waveRegionText(newRegion, newRegion.data.tag);
        });
    }

    if (window.waveReport) window.waveReport();

    isLoadingData = false;
}

window.waveLoadData = waveLoadData;
/**
 * Updates all region colors on the waveform based on the single
 * `currentlyActiveRegionId` variable.
 */
function updateAllRegionHighlights() {
    if (!window.wavesurfer || !window.wavesurfer.regions) return;

    const highlightColor = 'rgba(128, 128, 128, 0.5)'; // Semi-transparent grey

    Object.values(window.wavesurfer.regions.list).forEach(region => {
        // Highlight if the region ID matches the active ID, otherwise remove highlight.
        const isHighlighted = (region.id === currentlyActiveRegionId);

        if (isHighlighted) {
            if (region.color !== highlightColor) {
                if (!region.data.originalColor) {
                    region.data.originalColor = region.color;
                }
                region.update({ color: highlightColor });
            }
        } else {
            if (region.data.originalColor && region.color !== region.data.originalColor) {
                region.update({ color: region.data.originalColor });
            }
        }
    });
}
function init() {
    createInlineTagTooltip(); 
    frm.loading('Loading Task...');
    transcriptionMode = descriptor.transcriptionMode ? true : false;

    // 1. Initialize Modes
    totalModes = [];
    if (descriptor.segmentation && descriptor.segmentation.length) {
        console.debug("segment reach", descriptor.segmentation, descriptor.segmentation.length)
        for (var s of descriptor.segmentation) {
            console.debug("segment not reach", s, descriptor.segmentation)
            s.type = 'segmentation';
            s.mode = s.name;
            if (!s.colors) s.colors = ['#ff0000', '#00ff00', '#0000ff'];
            totalModes.push(s);
        }
    } else {
        console.debug("hello-->here issue");
        console.debug("segment reach", descriptor.segmentation, descriptor.segmentation.length)
        totalModes.push({
            id: 0,
            name: 'Default',
            mode: 'segmentation',
            type: 'segmentation',
            options: ['Agent', 'Customer', 'Noise'],
            colors: ['#ff0000', '#00ff00', '#808080'],
            'Drop-Down options': ['Speech', 'Music', 'Noise'],
            DropDown: true,
            allowNew: true
        });
    }

    totalModes.forEach((m, idx) => m.id = idx);

    // 2. Clear UI
    $('#videotrackanotate').html('');
    $('crowd-form').hide();

    // 3. Initialize WaveSurfer
    if (descriptor.DRMData && !descriptor.DRMData.init) {
        descriptor.DRMData.init = function () { init(); };
        return;
    }
    if (transcriptionMode) $('video').addClass('video-transcript');

    // Instantiate Tracks
    var tr = new tracks($('#videotrackanotate'), $('#video'), null, tagData, $('#reportpanel'));
    window.trackObj = tr;

    // --- CRITICAL FIX: This line fixes "descriptor.waveMode is not a function" ---
    descriptor.waveMode = window.waveMode;

    // Initialize UI
    setupTranscriptionImport();

    // Trigger the buttons to appear
    if (totalModes.length > 0 && window.waveMode) {
        window.waveMode(0);

        // --- FIX START: Use a setTimeout to prevent a race condition ---
        // After a task is claimed, the entire UI is re-rendered. A short delay
        // ensures that all DOM elements (including the cloned buttons in the zoom panel)
        // are fully created before we programmatically select the first one. This
        // guarantees the "selected" style is applied correctly every time.
        setTimeout(function() {
            // Only select a default tag if editing is actually allowed
            if (typeof window.waveSegSelect === 'function' && !descriptor.blockEdit) {
                 window.waveSegSelect(0);
            }
        }, 100); // A 100ms delay is sufficient for the DOM to update.
        // --- FIX END ---
    }

    console.debug("descriptor for Label Task", Object(descriptor.labelForTagging));
    // Initialize Table
    setTimeout(function () {
        if (typeof window.waveReport === 'function') {
            window.waveReport();
        }
    }, 500);

    if (!tagData.attributes) $('#video-attr').hide();
    if (!tagData.mediaAttributes) tagData.mediaAttributes = {};
    listAttributes($('#video-attr'), tagData.attributes, tagData.mediaAttributes, 'Media Attributes');

    var form = document.querySelector('crowd-form');
    setButtons(descriptor);
    showSave('Session started', descriptor.sessionStart * 1000)

    $('#submitButton').on('click', function () {
        declined = false;
        if (form) form.submit();
        else submitAnnotations();
    });
}

// function setupTranscriptionImport() {
//     // 1. Create the UI elements
//     const importButton = $('<button class="btn btn-secondary btn-sm mb-2" id="import-draft-btn">Import Draft File</button>');
//     const fileInput = $('<input type="file" accept=".txt,.json" style="display: none;" id="draft-file-input">');

//     // The Align button is now simpler. It doesn't need its own file input.
//     const alignButton = $('<button class="btn btn-primary btn-sm mb-2 ml-2" id="align-btn" style="display:none;">Align Transcript</button>');
//     const statusDiv = $('<div id="align-status" class="mb-2" style="font-style: italic; color: #6c757d;"></div>');

//     // Add elements to the report panel
//     $('#reportpanel').before(importButton, alignButton, fileInput, statusDiv);

//     // 2. Wire up the buttons
//     importButton.on('click', function() {
//         fileInput.click();
//     });

//     fileInput.on('change', function(event) {
//         const file = event.target.files[0];
//         if (!file) return;

//         const reader = new FileReader();
//         reader.onload = function(e) {
//             const content = e.target.result;
//             parseTranscription(content);
//             waveReport();
//             changed();
//             fileInput.val('');
//             alignButton.show(); // Show the Align button after import
//             statusDiv.text('Draft loaded. Click "Align Transcript" to get timestamps.');
//         };
//         reader.readAsText(file);
//     });

//     // 3. The Align button now directly triggers the alignment process
//     alignButton.on('click',  function() {
//          handleAlignment();
//     });
// }


// REPLACE the existing parseTranscription function with this
function parseTranscription(textContent) {
    const lines = textContent.split('\n').filter(line => line.trim() !== '');
    const speakerMap = {
        'speaker1': 'Customer',
        'speaker2': 'Representative'
    };

    descriptor.transcript = lines.map((line, index) => {
        const match = line.match(/^(speaker\d+):\s*(.*)/);
        if (match) {
            return {
                id: `line-${index}`,
                speaker: speakerMap[match[1]] || match[1],
                dialogue: match[2].trim(),
                start: null,
                end: null,
                words: [] // Prepare array to hold timed words
            };
        }
        return {
            id: `line-${index}`,
            speaker: 'Unknown',
            dialogue: line.trim(),
            start: null,
            end: null,
            words: [] // Prepare array to hold timed words
        };
    }).filter(item => item.dialogue);

    console.log("Parsed Transcription Data into descriptor.transcript");
}
function exists(o) {
    if (!o) return false;
    if (!isobj(o) && !isarray(o)) return false;
    return Object.keys(o).length > 0;
}


function showHide(o, cond) {
    if (cond) o.show();
    else o.hide();
}

var chatNotificationRead = false;
function displayNotes() {
    // return;
    $('#messages').remove();
    if (descriptor.reviewMode) {
        $('#reviewer_notes').hide();
        $('#submitReviewer').show();
    }
    else {
        // $('#messages').hide();
        $('#annotator_notes').hide();
        $('#submitReviewer').hide();
    }
    $('#chatbox').removeClass('unselectable').css({ position: 'relative' });
    $('#chat_notification').hide();
    $('#chatbox').off('click').on('click', chatPopup);
    if (!chatNotificationRead)
        if ($('#reviewer_notes').val().trim() || $('#annotator_notes').val().trim() || (descriptor.messages && descriptor.messages.length)) $('#chat_notification').css({ marginTop: 3 }).show();
    ;
}

function chatPopup() {
    let content = '<div id="messages" class="file-messages"></div>';
    if (descriptor.reviewMode) {
        content += '<textarea id="chat_reviewer_notes" class="inote-text mt-2" placeholder="Reviewer Notes"></textarea>';
    }
    else {
        content += '<textarea id="chat_annotator_notes" class="inote-text mt-2" placeholder="Annotator Notes"></textarea>';
    }
    frm.myAlert('Messages', content, 'Ok');
    displayMessages();
    if (blockEdit) {
        $('.modal-body').find('textarea').attr('disabled', true);
    }
    setTimeout(function () {
        $('.modal-body').scrollTop(100000)
        if (!blockEdit) {
            if (descriptor.reviewMode) {
                $('#chat_reviewer_notes')[0].focus();
            }
            else {
                $('#chat_annotator_notes')[0].focus();
            }
        }
        else {
            $('#chat_annotator_notes').val('')
        }
    }, 500)

    // copy notes to original text area for compatibility
    $('#chat_reviewer_notes').on('change', function () {
        $('#reviewer_notes').val($(this).val());
        changed();
    }).val($('#reviewer_notes').val())
    $('#chat_annotator_notes').on('change', function () {
        $('#annotator_notes').val($(this).val());
        descriptor.mediaAttributes["Aditional Notes"] = $(this).val();
        changed()
    }).val($('#annotator_notes').val())
    if (blockEdit) $('#chat_annotator_notes').val('')


    chatNotificationRead = true;
    $('#chat_notification').hide();
}


function displayMessages() {
    if (!descriptor.messages) return;
    $('#messages').show().html('');
    var role = ['Annotator', 'QC'];

    var showMoreLess = $('<DIV>').addClass('message-show');
    $('#messages').append(showMoreLess);
    var nshow = 2;
    var nmess = descriptor.messages.length;
    function showMore() {

    }
    function show() {
        var hidden = 0;
        for (var i = 0; i < nmess - nshow; i++) {
            $('.message-idx-' + i).hide();
            hidden++;
        }
        for (; i < nmess; i++)
            $('.message-idx-' + i).show();
        if (hidden) {
            showMoreLess.text('Show more messages').off('click').on('click', function () {
                nshow += 3;
                show();
            });
        }
        else if (nmess > 2) {
            showMoreLess.text('Show less messages').off('click').on('click', function () {
                nshow = 1;
                show();
            });
        }
    }

    descriptor.messages.forEach((m, idx) => {
        var m = $('<DIV>').addClass('message-' + m[0]).addClass('message-idx-' + idx).html('<i>' + role[m[0]] + '</i><br>' + m[1]);
        $('#messages').append(m);
    });
    // show();
}


function displayMessagesOld() {
    $('#messages').show().html('');
    var role = ['Annotator', 'QC'];

    var showMoreLess = $('<DIV>').addClass('message-show');
    $('#messages').append(showMoreLess);
    var nshow = 2;
    var nmess = descriptor.messages.length;
    function showMore() {

    }
    function show() {
        var hidden = 0;
        for (var i = 0; i < nmess - nshow; i++) {
            $('.message-idx-' + i).hide();
            hidden++;
        }
        for (; i < nmess; i++)
            $('.message-idx-' + i).show();
        if (hidden) {
            showMoreLess.text('Show more messages').unbind('click').on('click', function () {
                nshow += 3;
                show();
            });
        }
        else if (nmess > 2) {
            showMoreLess.text('Show less messages').unbind('click').on('click', function () {
                nshow = 1;
                show();
            });
        }
    }

    descriptor.messages.forEach((m, idx) => {
        var m = $('<DIV>').addClass('message-' + m[0]).addClass('message-idx-' + idx).html('<i>' + role[m[0]] + '</i><br>' + m[1]);
        $('#messages').append(m);
    });
    show();
}


var questionMode = false;
var currentQuestion = 0;

function start(desc) {
    console.log("RAW DESCRIPTOR FROM SERVER:", JSON.parse(JSON.stringify(desc)));
    descriptor = tagData = desc;
    window.descriptor = descriptor;
    reviewMode = descriptor.reviewMode ? true : false;

    // Ensure report panel element exists and is visible
    if (!$('#reportpanel').length) {
        console.error("Report panel element #reportpanel not found in DOM!");
    } else {
        console.log("Report panel element found, ensuring it's visible...");
        $('#reportpanel').show();
    }

    if (mode == 'template') $('#resumeLater').hide();
    $('#reviewer-fields').hide();
    $('#annotator_notes').show();
    if (descriptor.reviewMode) {
        $('#reviewer-fields').show();
        $('#annotator_notes').hide();
        if (!descriptor.reviewMayRequestAdjustment) $('#optadjust').remove();
    }
    if (!exists(descriptor.messages)) $('#messages').hide();
    else displayMessages();
    $('#reviewer_rate').on('change', changed);
    $('#reviewer_notes').on('change', changed);
    $('#annotator_notes').on('change', changed);
    var now = getsec();
    if (!descriptor.elapsedTime) {
        descriptor.elapsedTime = 0;
        if (!descriptor.jobStart) descriptor.jobStart = now;
    }
    else if (!descriptor.tsSeconds) descriptor.elapsedTime /= 1000;
    descriptor.sessionStart = now;

    if (mode != 'template') {
        $(document.body).css({ overflow: 'hidden' });
    }

    if (!descriptor.questionnaire || !descriptor.questionnaire.length) init();
    else {
        questionMode = true;
        function submitQuestions() {
            var annotations = { videoData: descriptor.videoData, annotations: clone(descriptor.questionnaireAnnotations) };
            if (document.location.href.indexOf('localhost') >= 0) saveClipboard(JSON.stringify(annotations.annotations))
            if (annotations) {
                document.getElementById('annotations').value = JSON.stringify(annotations);
                $('crowd-form').show();
                $('crowd-form')[0].onsubmit = null;
                $('crowd-form')[0].submit();
            }
            else
                return false;
        }

        function question(q) {
            function save(callback) {
                // if( 0 && !questionData.answer )
                // {
                // 	modal( 'Answer Required', 'Please answer the question' );
                // 	return false;
                // }
                questionData.streams = tr.saveTracks();
                var nev = 0;
                questionData.streams.forEach(e => {
                    nev += e.ranges.length;
                });
                if (questionData.false && !questionData.userAnswer) {
                    return modal('Answer Required', 'Please write the correct answer for the question.', 'Ok', function () {
                        modalWait(function () {
                            $('#questionUserAnswer').focus();
                        })
                    })
                }
                if (!nev) {
                    if (questionData.streams.length) return modal('Record Evidence Position', "You must record the evidence position in the video.")
                    modal('Evidence Required', 'Please annotate evidences about your answer.');
                    return;
                }
                console.log('streams', questionData.streams);
                if (!questionData.false) delete questionData.userAnswer;
                descriptor.questionnaireAnnotations[q] = questionData;
                // if( nev && !questionData.false )
                // {
                // 	return modal( 'Discard Evidence', 'You selected the answer as <b>True</b>. Discard current annotated evidences?', 'Discard Evidences', function(){
                // 		modalWait( function(){
                // 			questionData.streams = [];
                // 			callback();
                // 		} );
                // 	} );
                // }
                $('#questionUserAnswer').unbind('change')
                callback();
                return true;
            }
            $('#prevnextBox').show();
            // if( q == descriptor.questionnaire.length ) return submitQuestions();
            var qlab = descriptor.questionnaire[q].question;
            currentQuestion = q;

            if (!descriptor.questionnaireAnnotations) descriptor.questionnaireAnnotations = {};
            if (!descriptor.questionnaireSettings) descriptor.questionnaireSettings = {};
            if (!descriptor.questionnaireAnnotations[currentQuestion]) descriptor.questionnaireAnnotations[currentQuestion] = {};
            $('#questionTitle').html('Q.: ' + descriptor.questionnaire[currentQuestion].question);
            $('#questionInstructions').html(descriptor.questionnaireInstructions || '');
            $('crowd-form').hide();
            $('#videotrackanotate').html('');
            $('#reportpanel').html('');
            var tr = new tracks($('#videotrackanotate'), $('#video'), null, tagData, $('#reportpanel'));

            // Ensure report panel is populated for questionnaire mode
            setTimeout(function () {
                if (window.ensureReportPanel) {
                    window.ensureReportPanel();
                }
            }, 300);

            var questionData = descriptor.questionnaireAnnotations[currentQuestion];
            questionData.question = qlab;
            questionData.answer = descriptor.questionnaire[currentQuestion].answer
            // questionData.userAnswer = descriptor.questionnaire[currentQuestion].userAnswer
            // $('#questionAnswer').val(questionData.answer).unbind('change').on('change',function(){ questionData.answer = $(this).val().trim()});
            $('#questionAnswer').html('A.: ' + questionData.answer);
            showHide($('#questionUserAnswer'), questionData.false);
            checkBox($('#questionFalse'), 'False', questionData.false, function (v) {
                questionData.false = v;
                showHide($('#questionUserAnswer'), v);
            });
            $('#questionUserAnswer').val(questionData.userAnswer).unbind('change').on('change', function () {
                questionData.userAnswer = $(this).val();
                console.error('userAnswer', questionData.userAnswer)
            })

            setTimeout(function () {
                console.log('questionData', questionData)
                tr.loadTracks(questionData.streams);
            }, 100);

            if (!tagData.attributes) $('#video-attr').hide();
            if (!tagData.mediaAttributes) tagData.mediaAttributes = {};
            listAttributes($('#video-attr'), tagData.attributes, tagData.mediaAttributes, 'Media Attributes')
            // function submitAnnotations(ev) {
            //     save(function () {
            //         submitQuestions
            listAttributes($('#video-attr'), tagData.attributes, tagData.mediaAttributes, 'Media Attributes')
            // function submitAnnotations(ev) {
            //     save(function () {
            //         submitQuestions()
            //     });
            // };
            // if (q < descriptor.questionnaire.length - 1) $('#submitBox').hide();
            // else $('#submitBox').show();
            $('.trackaddbutton').html(descriptor.questionnaire[currentQuestion].button);
            $('.prevnext_number').html('<span>' + (q + 1) + ' of ' + descriptor.questionnaire.length + '</span>')
            $('#buttonPrev').prop('disabled', q == 0).unbind('click').on('click', function () {
                save(function () {
                    question(currentQuestion - 1)
                })
            });
            $('#buttonNext').prop('disabled', q == descriptor.questionnaire.length - 1).unbind('click').on('click', function () {
                save(function () {
                    question(currentQuestion + 1)
                })
            });
            $('#submitButton').off('click').on('click', submitAnnotations);
        }
        $('#video-attr').hide();
        question(0);
    }
}

// EXPORTEND
var declined = false;
var claimed = false;
var released = false;
var blockEdit = false;

function fixButtons(descriptor) {
    if (!descriptor) return;
    $('.task-button').hide();
    $('.mode-select').hide();
    $('.claim-button').html('Claim Task as ' + descriptor.task_role);
    $('#reviewer_rate_div').hide();

    // --- FIX START ---
    // Hide the export button by default. It will be shown below only if the role is 'Reviewer'.
    $('.export-button').hide();
    // --- FIX END ---

    if (descriptor.task_role) {
        // --- FIX START ---
        // Conditionally show the export button based on the user's role.
        if (descriptor.task_role === 'Reviewer') {
            $('.export-button').show();
        }
        // --- FIX END ---

        if (descriptor.blockEdit) { // This is true when the task is NOT claimed
            if (descriptor.task_can_claim) {
                if (descriptor.task_auto_claim) {
                    setTimeout(function () {
                        $('.claim-button')[0].click();
                    }, 1);
                } else {
                    $('.claim-button').show();
                }
            }
            $('#resumeLater').hide();
        } else { // This is true when the task IS claimed
            if (descriptor.task_role == 'Reviewer') {
                $('#reviewer_rate_div').show();
            }
            $('#resumeLater').show();
            $('.claim-button').hide();
            $('.submit-button').show();
            $('.autolabel-button').show();
            if (descriptor.task_can_decline) $('.decline-button').show();
            if (descriptor.task_can_release) {
                $('.release-button').show();
            }
        }
    }
    
    reviewMode = descriptor.reviewMode;
    if (descriptor.reviewMode) {
        $('#reviewer-fields').show();
        $('#annotator_notes').hide();
        if (!descriptor.reviewMayRequestAdjustment) $('#optadjust').remove();
    }
    blockEdit = descriptor.blockEdit;
    displayNotes();
    if ($('.player-seek-bar').length) {
        $('.player-seek-bar').toggleClass('task-locked', descriptor.blockEdit);
    }
     if (!descriptor.blockEdit && typeof window.waveSegSelect === 'function') {
        setTimeout(function() {
            // We re-check the condition in case the state changes again quickly.
            if (window.descriptor && !window.descriptor.blockEdit) {
                window.waveSegSelect(0);
            }
        }, 150);
    }
}

/**
 * Recursively searches for a tag by its ID within a nested taxonomy structure.
 * @param {string} id The ID of the tag to find.
 * @param {Array} nodes The array of tag nodes to search through.
 * @returns {object|null} The found tag object or null.
 */
function findTagById(id, nodes) {
    for (const node of nodes) {
        if (node.id === id) {
            return node;
        }
        if (node.children && node.children.length > 0) {
            const found = findTagById(id, node.children);
            if (found) {
                return found;
            }
        }
    }
    return null;
}

/**
 * Converts annotated HTML content into a string with specified output format tags.
 * @param {string} htmlContent The HTML string from the content-editable div.
 * @param {Array} taxonomy The taxonomy array (descriptor.labelForTagging).
 * @returns {string} The formatted string with output tags (e.g., "<Overlap>text</Overlap>").
 */
function generateTaggedOutput(htmlContent, taxonomy) {
    if (!htmlContent || !taxonomy || taxonomy.length === 0) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        return tempDiv.textContent || "";
    }

    const $content = $('<div>').html(htmlContent);

    $content.find('.annotation-tag').each(function() {
        const $span = $(this);
        const tagId = $span.attr('data-tag-id');
        const tagData = findTagById(tagId, taxonomy);

        if (tagData && tagData.outputFormat) {
            const innerText = $span.clone().find('.tag-label-on-span').remove().end().text();
            const replacementString = (tagData.outputFormat.start || '') + innerText + (tagData.outputFormat.end || '');
            $span.replaceWith(replacementString);
        } else {
            $span.replaceWith($span.text());
        }
    });

    return $content.html();
}
function exportJson() {
    if (!window.wavesurfer || !window.wavesurfer.regions || !descriptor.currentMode) {
        console.error("WaveSurfer, regions, or currentMode not found for export.");
        return null;
    }

    const regions = Object.values(window.wavesurfer.regions.list);
    const currentMode = descriptor.currentMode;
    const isTransliterationEnabled = $('#transliterate-toggle').is(':checked');

    const tagsWithoutSpeakerId = new Set();
    const transcriptionInlineRules = currentMode['Transcription Inline'] || [];
    transcriptionInlineRules.forEach(rule => {
        if (typeof rule === 'string' && rule.startsWith('#NOJSON_')) {
            const tagName = rule.substring(8);
            if (tagName) {
                tagsWithoutSpeakerId.add(tagName);
            }
        }
    });

    if (regions.length === 0) {
        return { [currentMode.mode]: [] };
    }

    regions.sort((a, b) => a.start - b.start);

    let segmentCounter = 1;
    let speakerIdCounter = 1;
    const speakerIdMap = new Map();

    const formattedSegments = regions.map(r => {
        const speakerName = r.data.tag || 'Unknown';
        const primaryType = (r.data.tone || "").trim();
        const validTranscriptionTypes = transcriptionInlineRules.filter(rule => !rule.startsWith('#NOJSON_'));
        const includeTranscription = validTranscriptionTypes.includes(primaryType);
        const segmentLangRaw = r.data.segmentLanguage || "";
        const segmentLanguagesArray = segmentLangRaw.split(',').map(lang => lang.trim()).filter(lang => lang);

        // --- THIS IS THE CORRECTED LOGIC ---

        const segment = {
            "start": formatTimeWithMilliseconds(r.start),
            "end": formatTimeWithMilliseconds(r.end),
            "primaryType": primaryType,
            "loudnessLevel": (r.data.loudness || "").trim(),
            "language": r.data.language || "",
            "segmentLanguages": segmentLanguagesArray,
        };

        if (includeTranscription) {
            // Generate content with output format tags for export
            let exportContent = r.data.annotatedHtml 
                ? generateTaggedOutput(r.data.annotatedHtml, descriptor.labelForTagging || [])
                : r.data.transcription || "";

            const transcriptionData = {
                "content": exportContent
            };

            if (isTransliterationEnabled) {
                // FIX: Process the annotated HTML for transliteration to include tags in the export
                const exportTransliteration = r.data.annotatedHtmlTransliteration 
                    ? generateTaggedOutput(r.data.annotatedHtmlTransliteration, descriptor.labelForTagging || [])
                    : r.data.transcriptionLatin || "";

                transcriptionData.transliteration = exportTransliteration;
            }

            segment.transcriptionData = transcriptionData;
        }

        segment.segmentId = (segmentCounter++).toString().padStart(3, '0');

        if (!tagsWithoutSpeakerId.has(speakerName)) {
            if (!speakerIdMap.has(speakerName)) {
                speakerIdMap.set(speakerName, `F${(speakerIdCounter++).toString().padStart(2, '0')}`);
            }
            segment.speakerId = speakerIdMap.get(speakerName);
        }

        return segment;
        // --- END OF CORRECTED LOGIC ---
    });

    return { [currentMode.mode]: formattedSegments };
}

/**
 * Validates all annotation segments, prioritizing transcription errors.
 * Checks if segments that require transcription or transliteration have non-empty text.
 * @returns {Array} An array of invalid region objects. Returns an empty array if all are valid.
 */
function validateAnnotations() {
    const invalidRegions = [];
    if (!window.wavesurfer || !descriptor.currentMode) {
        return invalidRegions;
    }

    const regions = Object.values(window.wavesurfer.regions.list);
    const currentMode = descriptor.currentMode;
    const transcriptionInlineTypes = currentMode['Transcription Inline'] || [];
    // This is the key: read the toggle state at the moment of validation.
    const isTransliterationEnabled = $('#transliterate-toggle').is(':checked');

    for (const region of regions) {
        const primaryType = (region.data.tone || "").trim();

        // Only check regions that are configured to have transcriptions.
        if (transcriptionInlineTypes.includes(primaryType)) {
            const transcription = (region.data.transcription || "").trim();
            const transliteration = (region.data.transcriptionLatin || "").trim();

            // Prioritize transcription error. If it's empty, report that and stop checking this region.
            if (transcription === '') {
                invalidRegions.push({
                    id: region.id,
                    speaker: region.data.tag || 'Unknown',
                    rowNumber: $(`#wavereport${region.id}`).find('td:first').text(),
                    errorType: 'transcription' // Add error type for specific messaging
                });
            }
            // Only if transcription is filled, check for required transliteration.
            else if (isTransliterationEnabled && transliteration === '') {
                invalidRegions.push({
                    id: region.id,
                    speaker: region.data.tag || 'Unknown',
                    rowNumber: $(`#wavereport${region.id}`).find('td:first').text(),
                    errorType: 'transliteration' // Add error type
                });
            }
        }
    }
    return invalidRegions;
}
function handleExportJSON() {
    // --- FIX: Check for empty segments before proceeding with export ---
    if (!window.wavesurfer || !window.wavesurfer.regions || Object.keys(window.wavesurfer.regions.list).length === 0) {
        myAlert('Export Not Allowed', 'There are no segments to export. Please create at least one segment before exporting.');
        return; // Stop the export process immediately
    }
    // --- END FIX ---

    // This is the final step that creates the file.
    const executeExport = () => {
        var annotationData = exportJson();
        if (annotationData) {
            var jsonString = JSON.stringify(annotationData, null, 2);
            var blob = new Blob([jsonString], { type: "application/json" });
            var url = URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = url;
            let exportFileName = 'annotations.json';

            // Safely access the nested File property from the descriptor.
            if (descriptor && descriptor.media && descriptor.media.metadata && descriptor.media.metadata.File) {
                const originalFileName = descriptor.media.metadata.File;
                // Get the base name by removing the original file extension.
                const baseName = originalFileName.replace(/\.[^/.]+$/, "");
                // Append the new .json extension.
                exportFileName = `${baseName}.json`;
            }
            link.download = exportFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } else {
            myAlert('Export Error', 'There was an error generating the export data.');
        }
    };

    // --- STEP 1: INITIAL VALIDATION ---
    const invalidRegions = validateAnnotations();
    if (invalidRegions.length > 0) {
        const firstInvalid = invalidRegions[0];
        let alertMessage = (firstInvalid.errorType === 'transliteration')
            ? `Transliteration is required for segment <b>#${firstInvalid.rowNumber}</b> (Speaker: ${firstInvalid.speaker}) because the feature is currently enabled.`
            : `Transcription is required for segment <b>#${firstInvalid.rowNumber}</b> (Speaker: ${firstInvalid.speaker}).`;
        myAlert('Validation Error', alertMessage, 'Ok');
        $('.table-row-invalid').removeClass('table-row-invalid');
        $('#wavereport' + firstInvalid.id).addClass('table-row-invalid');
        return;
    }

    // --- STEP 2: CHECK FOR HIDDEN TRANSLITERATION DATA ---
    const isTransliterationEnabled = $('#transliterate-toggle').is(':checked');
    let hasHiddenData = false;
    if (!isTransliterationEnabled) {
        Object.values(window.wavesurfer.regions.list).forEach(region => {
            if (region.data.transcriptionLatin && region.data.transcriptionLatin.trim() !== '') {
                hasHiddenData = true;
            }
        });
    }

    if (hasHiddenData) {
        myAlert(
            'Confirm Transliteration Export',
            'You have transliteration data, but the feature is currently disabled. Do you want to re-enable it and include this data in the export?',
            '^Yes, Include Data',
            function() {
                // --- THIS IS THE FIX ---
                $('#transliterate-toggle').prop('checked', true).trigger('change');
                myAlertClose(() => {
                    setTimeout(() => {
                        // RE-VALIDATE against the new state.
                        const newInvalidRegions = validateAnnotations();
                        if (newInvalidRegions.length > 0) {
                            // If the new validation fails, show the specific error.
                            const firstInvalid = newInvalidRegions[0];
                            const alertMessage = `Transliteration is required for segment <b>#${firstInvalid.rowNumber}</b> (Speaker: ${firstInvalid.speaker}) because the feature is now enabled. Please fill in the required field.`;
                            myAlert('Validation Error', alertMessage, 'Ok');
                            $('.table-row-invalid').removeClass('table-row-invalid');
                            $('#wavereport' + firstInvalid.id).addClass('table-row-invalid');
                        } else {
                            // Only if the second validation passes, proceed to export.
                            executeExport();
                        }
                    }, 50);
                });
            },
            'No, Export Without',
            function() {
                myAlertClose(executeExport);
            }
        );
    } else {
        // No validation errors and no hidden data, proceed directly to export.
        executeExport();
    }
}
function setButtons(descriptor, form) {
    // Create the Export button with styling and an icon
    var exportBtn = $('<button type="button" class="btn btn-info mr-2 task-button export-button">')
        .html('<i class="fa fa-download" aria-hidden="true" style="margin-right: 5px;"></i>Export');
    exportBtn.on('click', function (event) {
        // Prevent the form from submitting
        if (event) event.preventDefault();
        handleExportJSON();
    });
    $('#submitBox').prepend(exportBtn);
    $('#submitButton').removeClass('mt-2').addClass('mr-2').addClass('submit-button').addClass('task-button');
    var claimBtn = $('<button type="submit" class="btn btn-primary btn-primary mr-2 task-button claim-button">').html('Claim Task');
    $('#submitButton').before(claimBtn);
    claimBtn.on('click', function () {
        claimTask(descriptor);
    });
    var declineBtn = $('<button type="submit" class="btn  btn-danger mr-2 task-button decline-button">').html('<i class=" mr-2 fa fa-ban" aria-hidden="true"></i>Decline  ');
    $('#submitButton').after(declineBtn);

    // --- THIS IS THE FIX, BASED ON YOUR TEMPLATE ---
    declineBtn.on('click', function (event) {
        event.preventDefault(); // Prevent the button from submitting the form immediately.

        // This creates the HTML content for the popup, including the textarea.
        const modalBody = $(
            '<div>' +
                '<p>Please provide a reason for declining the task.</p>' +
                '<textarea id="decline_reason" placeholder="Enter reason..." class="form-control" style="min-height: 80px;"></textarea>' +
                '<div id="decline-error" class="text-danger mt-2" style="display:none; font-size: 0.8rem;">A reason is required to decline the task.</div>' +
            '</div>'
        );

        myAlert(
            'Decline Task', // Popup Title
            modalBody,      // The HTML content with the textarea
            '*Ok',          // OK button (the '*' makes it red/dangerous)
            function() {
                // This code runs when the user clicks "Ok".
                const reason = $('#decline_reason').val().trim();

                // Validation: Check if the reason is empty.
                if (reason === '') {
                    $('#decline-error').show(); // Show the error message.
                    return; // Stop and keep the popup open.
                }

                // If valid, store the reason and set the global state.
                declineReason = reason;
                declined = true;
                claimed = false;
                released = false;

                // Close the popup and proceed with the submission process.
                myAlertClose(function() {
                    if (form) form.submit();
                    else submitAnnotations();
                });
            },
            'Cancel',       // Cancel button
            function() {
                // If "Cancel" is clicked, just close the popup.
                myAlertClose();
            }
        );
    });
    // --- END OF FIX ---

    var releaseBtn = $('<button type="submit" class="btn btn-primary btn-warning mr-2 task-button release-button">').html('<i class=" mr-2 fa fa-unlock" aria-hidden="true"></i>Release');
    declineBtn.after(releaseBtn);
    releaseBtn.on('click', function () {
        releaseTask(descriptor);
    });
    descriptor.fixButtons = fixButtons;
    fixButtons(descriptor);
}


var claimTask = function (d) {
    descriptor.claimCallback(d);
}

var releaseTask = function (d) {
    descriptor.releaseCallback(d);
}


// ADL
var submitAnnotations = async function () {
    // This is the final step that sends the data.
    const executeSubmit = async () => {
        var annotations = exportData();
        if (annotations) {
            if (descriptor.reviewMode) {
                if (!annotations.review) annotations.review = {};
                annotations.review.reviewerId = window.GlobalVars.userId || window.GlobalVars.userWorkerId;
                annotations.review.rate = $('#reviewer_rate').val() || '';
                annotations.review.note = $('#reviewer_notes').val().trim() || '';
            }
            clearTimeout(changeTid);
            descriptor.submit(annotations);
        } else {
            return false;
        }
    };

    // If the action is a decline, immediately execute the submission logic
    // and bypass all subsequent validation and confirmation popups.
    if (declined) {
        await executeSubmit();
        return; // Exit the function here.
    }

    // --- ALL CODE BELOW THIS POINT IS FOR A REGULAR SUBMISSION ---

    // --- STEP 1: RUN ALL VALIDATIONS FIRST ---
    if (descriptor.reviewMode) {
        if (!$('#reviewer_rate').val()) {
            myAlert('Submit Error', 'Please assign the quality of the annotations before submitting.');
            return false;
        }
        if ($('#reviewer_rate').val() === 'Adjust' && !$('#reviewer_notes').val().trim()) {
            myAlert('Submit Error', 'Please add a note to the annotator with your requests when asking for an adjustment.');
            return false;
        }
    }

    const invalidRegions = validateAnnotations();
    if (invalidRegions.length > 0) {
        const firstInvalid = invalidRegions[0];
        let alertMessage = (firstInvalid.errorType === 'transliteration')
            ? `Transliteration is required for segment <b>#${firstInvalid.rowNumber}</b> (Speaker: ${firstInvalid.speaker}) because the feature is currently enabled.`
            : `Transcription is required for segment <b>#${firstInvalid.rowNumber}</b> (Speaker: ${firstInvalid.speaker}).`;
        myAlert('Validation Error', alertMessage, 'Ok');
        $('.table-row-invalid').removeClass('table-row-invalid');
        $('#wavereport' + firstInvalid.id).addClass('table-row-invalid');
        return false;
    }

    // --- STEP 2: SHOW CONFIRMATION POPUP (only if validation passes) ---
    const confirmed = await frm.myConfirm(
        'Confirm Submit',
        "Do you really want to submit your annotations?",
        null, 
        "Yes, submit annotations", 
        "No"
    );
    if (!confirmed) {
        return false;
    }
    
    // --- STEP 3: CHECK FOR HIDDEN DATA & EXECUTE SUBMIT ---
    const isTransliterationEnabled = $('#transliterate-toggle').is(':checked');
    let hasHiddenData = false;
    if (!isTransliterationEnabled) {
        Object.values(window.wavesurfer.regions.list).forEach(region => {
            if (region.data.transcriptionLatin && region.data.transcriptionLatin.trim() !== '') {
                hasHiddenData = true;
            }
        });
    }

    if (hasHiddenData) {
        myAlert(
            'Confirm Transliteration on Submit',
            'You have transliteration data, but the feature is currently disabled. Do you want to re-enable it and include this data in your submission?',
            '^Yes, Include Data',
            function() {
                $('#transliterate-toggle').prop('checked', true).trigger('change');
                myAlertClose(() => {
                    setTimeout(async () => {
                        const newInvalidRegions = validateAnnotations();
                        if (newInvalidRegions.length > 0) {
                            const firstInvalid = newInvalidRegions[0];
                            const alertMessage = `Transliteration is required for segment <b>#${firstInvalid.rowNumber}</b> (Speaker: ${firstInvalid.speaker}) because the feature is now enabled. Please fill in the required field.`;
                            myAlert('Validation Error', alertMessage, 'Ok');
                            $('.table-row-invalid').removeClass('table-row-invalid');
                            $('#wavereport' + firstInvalid.id).addClass('table-row-invalid');
                        } else {
                            await executeSubmit();
                        }
                    }, 50);
                });
            },
            'No, Submit Without',
            async function() {
                myAlertClose(async () => await executeSubmit());
            }
        );
    } else {
        // If everything is valid and confirmed, submit the data.
        await executeSubmit();
    }
};

var updateFlag = false;
function updating() {
    return updateFlag;
}

function showSave(s, ts) {
    // descriptor.version = s;
    if (ts) s += ' - ' + new Date(ts).toLocaleString()
    $('#version').remove();
    $('#submit').hide();
    $('#t_right').prepend(
        $('<span>')
            .addClass('version')
            .prop('id', 'version')
            .html(s)
    );
}


var changeTid = null;
changed = function () {
    if (descriptor.blockEdit) return;
    console.log('changed');
    clearTimeout(changeTid);
    updateFlag = true;
    window.onbeforeunload = function (ev) {
        ev.preventDefault();
        return ev.returnValue = "Are you sure you want to exit?";
    };

    changeTid = setTimeout(function () {
        var annotations = exportData(1);
        if (!annotations) {
            console.error("Auto-save failed: exportData returned null.");
            return;
        }

        descriptor.update(annotations, res => {
            window.onbeforeunload = null;
            updateFlag = false;
            showSave('Saved', Date.now());
            // ADD THIS LINE FOR VERIFICATION
            console.log('Data sent to server for auto-save:', annotations);
        });
    }, 500);
};

function checkInstructions(descriptor) {
    if (descriptor.blockEdit) return;

    const engine = new Liquid();

    // --- THIS IS THE FIX ---
    // This line now checks for metadata inside descriptor.media before falling back.
    const data = (descriptor.pdf && descriptor.pdf.metadata) || (descriptor.media && descriptor.media.metadata) || descriptor.metadata;

    // Render a template using Liquid
    let itext = (descriptor.globalTaskInstructions && descriptor.globalTaskInstructions.text) || '';
    if (itext && data) { // Added a check for 'data' to prevent errors
        engine
            .parseAndRender(itext.replace(/\n/g, '<br>'), data)
            .then(result => {
                if (descriptor.globalTaskInstructions.showModal && descriptor.globalTaskInstructions.text) {
                    frm.myAlert('Instructions', result, 'Ok');
                }

                if (descriptor.globalTaskInstructions.text) {
                    if ($('#right').find('.instruct').length > 0) {
                        $('#right').find('.instruct').remove();
                    }

                    let instructionsBox = `
                    <div class="instruct">
                        <div class="panel-title">Instructions</div>
                        <p>${result || 'No Instrctions set'}</p>
                    </div>`

                    $('#right').prepend(instructionsBox)
                }
            })
            .catch(error => {
                console.error('Error rendering template:', error);
            });
    }
}
checkInstructions(descriptor);

myAlert = frm.myAlert;
myAlertClose = frm.myAlertClose;

// Function to ensure report panel is populated
function ensureReportPanel() {
    if (window.reportObj && typeof waveReport === 'function') {
        console.log("Manually ensuring report panel is populated...");

        // Make sure the report panel is visible
        if (window.reportObj.length && window.reportObj.is(':hidden')) {
            console.log("Report panel was hidden, making it visible...");
            window.reportObj.show();
        }

        // eslint-disable-next-line no-undef
        waveReport();
    } else {
        console.warn("Cannot populate report panel - reportObj or waveReport not available");
    }
}

// Make this function globally available
window.ensureReportPanel = ensureReportPanel;

// Add keyboard event listener for delete key functionality

// Function to remove table row corresponding to a deleted region
function removeTableRowForRegion(regionId) {
    try {
        // Look for table rows that might correspond to this region
        // Check multiple possible selectors for the table rows
        const possibleSelectors = [
            `tr[data-region-id="${regionId}"]`,
            `tr[data-id="${regionId}"]`,
            `tr[id="wavereport${regionId}"]`, // UPDATED: More specific selector
            `tr[data-wave-id="${regionId}"]`,
            `.annotation-row[data-region-id="${regionId}"]`,
            `.table-row[data-region-id="${regionId}"]`
        ];

        let rowFound = false;

        // Try each selector to find the corresponding row
        for (let selector of possibleSelectors) {
            const $row = $(selector);
            if ($row.length > 0) {
                console.log(`Found table row with selector: ${selector}`);
                $row.remove();
                rowFound = true;
                break;
            }
        }

        if (!rowFound) {
            console.warn(`Could not find table row for deleted region: ${regionId}`);
        } else {
            console.log(`Successfully removed table row for region: ${regionId}`);
        }

    } catch (error) {
        console.error("Error removing table row for region:", regionId, error);
    }
}

// Function to setup WaveSurfer region selection tracking
function setupRegionSelectionTracking() {
    if (window.wavesurfer && window.wavesurfer.regions) {
        // Listen for region click events to track selection
        window.wavesurfer.on('region-click', function (region, e) {
            // Clear previous selections
            for (let regionId in window.wavesurfer.regions.list) {
                const r = window.wavesurfer.regions.list[regionId];
                if (r.element) {
                    r.element.classList.remove('wavesurfer-region-selected');
                }
                r.selected = false;
            }

            // Mark the clicked region as selected
            if (region.element) {
                region.element.classList.add('wavesurfer-region-selected');
            }
            region.selected = true;
            window.selectedRegionId = region.id;

            // Also highlight the corresponding table row
            highlightTableRowForRegion(region.id);

            console.log("Region selected:", region.id);
        });

        // Listen for clicks outside regions to clear selection
        window.wavesurfer.on('click', function (e) {
            // Check if click was not on a region
            if (!e.target.closest('.wavesurfer-region')) {
                // Clear all selections
                for (let regionId in window.wavesurfer.regions.list) {
                    const r = window.wavesurfer.regions.list[regionId];
                    if (r.element) {
                        r.element.classList.remove('wavesurfer-region-selected');
                    }
                    r.selected = false;
                }
                window.selectedRegionId = null;

                // Clear table row highlighting
                clearTableRowHighlighting();

                console.log("All regions deselected");
            }
        });

        // Listen for table row clicks to select corresponding regions
        $(document).on('click', 'tr[data-region-id], tr[id^="wavereport"], .annotation-row, .table-row', function (e) {
            const $row = $(this);
            const rowId = $row.attr('id');
            const regionId = rowId ? rowId.replace('wavereport', '') : ($row.data('region-id') || $row.data('id'));

            if (regionId && window.wavesurfer.regions.list[regionId]) {
                // Clear previous selections
                for (let rId in window.wavesurfer.regions.list) {
                    const r = window.wavesurfer.regions.list[rId];
                    if (r.element) {
                        r.element.classList.remove('wavesurfer-region-selected');
                    }
                    r.selected = false;
                }

                // Select the corresponding region
                const region = window.wavesurfer.regions.list[regionId];
                if (region.element) {
                    region.element.classList.add('wavesurfer-region-selected');
                }
                region.selected = true;
                window.selectedRegionId = regionId;

                // Highlight this table row
                clearTableRowHighlighting();
                $row.addClass('selected-table-row');

                console.log("Region selected from table row:", regionId);
            }
        });
    }
}

// Function to highlight table row corresponding to selected region
function highlightTableRowForRegion(regionId) {
    try {
        // Clear previous highlighting
        clearTableRowHighlighting();

        const $row = $(`#wavereport${regionId}`);
        if ($row.length > 0) {
            $row.addClass('selected-table-row');
            console.log(`Highlighted table row for region: ${regionId}`);
        } else {
            console.log(`No table row found to highlight for region: ${regionId}`);
        }
    } catch (error) {
        console.error("Error highlighting table row for region:", regionId, error);
    }
}

// Function to clear table row highlighting
function clearTableRowHighlighting() {
    $('.selected-table-row').removeClass('selected-table-row');
}

// Initialize keyboard event listeners when the module loads
$(document).ready(function () {
    // setupKeyboardEventListeners();
    // Global event delegation for segmentation buttons - ensures clicks work after task claim
    // ADL
// Global event delegation for segmentation buttons - ensures clicks work after task claim
$(document).off('click.segmentation').on('click.segmentation', '.segmentation-opt', function (e) {
    if (window.descriptor && window.descriptor.blockEdit) {
        showLockAlert();
        return;
    }
    var index = $(this).attr('data-segindex');
    if (index !== undefined && index !== null) {
        window.waveSegSelect(parseInt(index));
    }
});

    // Setup region selection tracking when WaveSurfer is ready
    if (window.wavesurfer) {
        setupRegionSelectionTracking();
    } else {
        // Wait for WaveSurfer to be initialized
        const checkWaveSurfer = setInterval(function () {
            if (window.wavesurfer) {
                setupRegionSelectionTracking();
                clearInterval(checkWaveSurfer);
            }
        }, 100);
    }


});

export default { start, updating }